
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cUvUr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96637782db9b74d4$export$2e2bcd8739ae039; });
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $jAOBB = parcelRequire("jAOBB");

var $iSvIT = parcelRequire("iSvIT");

var $fDVJn = parcelRequire("fDVJn");

var $4r5yj = parcelRequire("4r5yj");

var $lLYBc = parcelRequire("lLYBc");

var $8CsyJ = parcelRequire("8CsyJ");

var $gLQGX = parcelRequire("gLQGX");
var $glx8J = parcelRequire("glx8J");

var $lB0RK = parcelRequire("lB0RK");
var $96637782db9b74d4$var$sectionMessageStyles = {
    container: "_2rko12b0 _1rjcpxbi _18zrpxbi _1nmz1hna",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr",
    dismissButtonContainer: "_19pk1i6y"
};
var $96637782db9b74d4$var$appearanceStyles = {
    information: "_bfhk33gi",
    warning: "_bfhk1tzq",
    error: "_bfhk1gly",
    success: "_bfhkmv6i",
    discovery: "_bfhk1nvp"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ var $96637782db9b74d4$var$SectionMessage = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function SectionMessage(_ref, ref) {
    var children = _ref.children, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "information" : _ref$appearance, actions = _ref.actions, title = _ref.title, icon = _ref.icon, isDismissible = _ref.isDismissible, onDismiss = _ref.onDismiss, testId = _ref.testId;
    var _useState = (0, $iSvIT.useState)(false), _useState2 = (0, $jAOBB.default)(_useState, 2), dismissed = _useState2[0], setDismissed = _useState2[1];
    var handleDismiss = (0, $iSvIT.useCallback)(function() {
        onDismiss === null || onDismiss === void 0 || onDismiss();
        setDismissed(true);
    }, [
        onDismiss
    ]);
    var _getAppearanceIconSty = (0, $lB0RK.getAppearanceIconStyles)(appearance, icon), primaryColor = _getAppearanceIconSty.primaryIconColor, secondaryColor = _getAppearanceIconSty.backgroundColor, Icon = _getAppearanceIconSty.Icon;
    var actionElements = actions && actions.type === (0, $iSvIT.Fragment) ? actions.props.children : actions;
    var actionsArray = (0, $iSvIT.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ $iSvIT.createElement("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $fDVJn.default)([
            $96637782db9b74d4$var$sectionMessageStyles.container,
            $96637782db9b74d4$var$appearanceStyles[appearance]
        ])
    }, /*#__PURE__*/ $iSvIT.createElement((0, $gLQGX.default), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ $iSvIT.createElement("div", {
        className: (0, $fDVJn.default)([
            $96637782db9b74d4$var$sectionMessageStyles.iconContainer
        ])
    }, /*#__PURE__*/ $iSvIT.createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        LEGACY_size: "medium",
        color: primaryColor,
        spacing: "spacious"
    })), /*#__PURE__*/ $iSvIT.createElement((0, $glx8J.default), {
        space: "space.100",
        testId: testId && "".concat(testId, "--content"),
        xcss: $96637782db9b74d4$var$sectionMessageStyles.contentContainer
    }, !!title && /*#__PURE__*/ $iSvIT.createElement((0, $lLYBc.default), {
        as: "h2",
        size: "small"
    }, title), /*#__PURE__*/ $iSvIT.createElement("div", {
        className: (0, $fDVJn.default)([
            $96637782db9b74d4$var$sectionMessageStyles.content
        ])
    }, children), actionsArray.length > 0 && /*#__PURE__*/ $iSvIT.createElement((0, $gLQGX.default), {
        shouldWrap: true,
        testId: testId && "".concat(testId, "--actions"),
        separator: "\xb7",
        space: "space.100",
        rowSpace: "space.0",
        role: actionsArray.length > 1 ? "list" : undefined,
        xcss: $96637782db9b74d4$var$sectionMessageStyles.actionsContainer
    }, actionsArray.map(function(action, id) {
        return(/*#__PURE__*/ // Only use a listitem role if more than one action is present
        $iSvIT.createElement((0, $gLQGX.default), {
            role: actionsArray.length > 1 ? "listitem" : undefined,
            key: id
        }, action));
    }))), isDismissible && /*#__PURE__*/ $iSvIT.createElement("div", {
        className: (0, $fDVJn.default)([
            $96637782db9b74d4$var$sectionMessageStyles.dismissButtonContainer
        ])
    }, /*#__PURE__*/ $iSvIT.createElement((0, $4r5yj.default), {
        testId: testId && "".concat(testId, "--dismiss-button"),
        label: "Dismiss",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8CsyJ))),
        appearance: "subtle",
        onClick: handleDismiss,
        spacing: "compact"
    }))));
});
$96637782db9b74d4$var$SectionMessage.displayName = "SectionMessage";
var $96637782db9b74d4$export$2e2bcd8739ae039 = $96637782db9b74d4$var$SectionMessage;

});
parcelRegister("jAOBB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e438a2514104cb7e$export$2e2bcd8739ae039; });

var $2yOgo = parcelRequire("2yOgo");

var $kHK7l = parcelRequire("kHK7l");

var $6kZZ4 = parcelRequire("6kZZ4");

var $2a0mj = parcelRequire("2a0mj");
function $e438a2514104cb7e$export$2e2bcd8739ae039(r, e) {
    return (0, $2yOgo.default)(r) || (0, $kHK7l.default)(r, e) || (0, $6kZZ4.default)(r, e) || (0, $2a0mj.default)();
}

});
parcelRegister("2yOgo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1dd5befde2d2ce23$export$2e2bcd8739ae039; });
function $1dd5befde2d2ce23$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("kHK7l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f12b98c681ac6c1c$export$2e2bcd8739ae039; });
function $f12b98c681ac6c1c$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("6kZZ4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49d4b1107e50f8f5$export$2e2bcd8739ae039; });

var $bySJ9 = parcelRequire("bySJ9");
function $49d4b1107e50f8f5$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $bySJ9.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $bySJ9.default)(r, a) : void 0;
    }
}

});
parcelRegister("bySJ9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86ad5259fb86868e$export$2e2bcd8739ae039; });
function $86ad5259fb86868e$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("2a0mj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $192ccb3b1d2d11d9$export$2e2bcd8739ae039; });
function $192ccb3b1d2d11d9$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("fDVJn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b63747b5c9b4909d$export$2e2bcd8739ae039; });
const $b63747b5c9b4909d$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $b63747b5c9b4909d$var$ATOMIC_GROUP_LENGTH = 5;
function $b63747b5c9b4909d$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $b63747b5c9b4909d$var$UNDERSCORE_UNICODE ? $b63747b5c9b4909d$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("4r5yj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33adfda2ef311cc6$export$2e2bcd8739ae039; });

var $ccHRj = parcelRequire("ccHRj");

var $8ymlm = parcelRequire("8ymlm");

var $iSvIT = parcelRequire("iSvIT");

var $kBwex = parcelRequire("kBwex");

var $fU7JN = parcelRequire("fU7JN");

var $4PIYf = parcelRequire("4PIYf");

var $10Awm = parcelRequire("10Awm");

var $lI79y = parcelRequire("lI79y");

var $jFVvO = parcelRequire("jFVvO");
var $33adfda2ef311cc6$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $33adfda2ef311cc6$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $33adfda2ef311cc6$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, unsafeRest = (0, $8ymlm.default)(_ref, $33adfda2ef311cc6$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $8ymlm.default)(unsafeRest, $33adfda2ef311cc6$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $10Awm.default), (0, $ccHRj.default)({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === "circle",
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $lI79y.default), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $jFVvO.default), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $4PIYf.default), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $fU7JN.default), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $10Awm.default), (0, $ccHRj.default)({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === "circle",
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $kBwex.default)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $lI79y.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $jFVvO.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $4PIYf.default), null, label)));
    });
}));
$33adfda2ef311cc6$var$IconButton.displayName = "IconButton";
var $33adfda2ef311cc6$export$2e2bcd8739ae039 = $33adfda2ef311cc6$var$IconButton;

});
parcelRegister("ccHRj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e28a07633f5f803$export$2e2bcd8739ae039; });
function $8e28a07633f5f803$export$2e2bcd8739ae039() {
    return $8e28a07633f5f803$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8e28a07633f5f803$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("8ymlm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63a2d4ab79ce502b$export$2e2bcd8739ae039; });

var $jmg7S = parcelRequire("jmg7S");
function $63a2d4ab79ce502b$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $jmg7S.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("jmg7S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e17c94b06d896624$export$2e2bcd8739ae039; });
function $e17c94b06d896624$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("kBwex", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0004439a3d4bc91$export$2e2bcd8739ae039; });
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $f0004439a3d4bc91$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("fU7JN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b942167f74a67fc6$export$2e2bcd8739ae039; });

var $ccHRj = parcelRequire("ccHRj");

var $jAOBB = parcelRequire("jAOBB");

var $azswa = parcelRequire("azswa");

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $4KkzB = parcelRequire("4KkzB");

var $9s0WO = parcelRequire("9s0WO");

var $2MOBR = parcelRequire("2MOBR");

var $17fqS = parcelRequire("17fqS");

var $1Z36a = parcelRequire("1Z36a");

var $iy0QV = parcelRequire("iy0QV");
var $g2f6i = parcelRequire("g2f6i");

var $jxLBU = parcelRequire("jxLBU");

var $gr749 = parcelRequire("gr749");

var $gWVOm = parcelRequire("gWVOm");

var $12inm = parcelRequire("12inm");

var $8mvDM = parcelRequire("8mvDM");

var $i7NIt = parcelRequire("i7NIt");

var $7aTue = parcelRequire("7aTue");

var $hLNJv = parcelRequire("hLNJv");

var $9Cyew = parcelRequire("9Cyew");
function $b942167f74a67fc6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b942167f74a67fc6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b942167f74a67fc6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $azswa.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b942167f74a67fc6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b942167f74a67fc6$var$tooltipZIndex = (0, $12inm.layers).tooltip();
var $b942167f74a67fc6$var$analyticsAttributes = {
    componentName: "tooltip",
    packageName: "@atlaskit/tooltip",
    packageVersion: "20.4.0"
};
// Inverts motion direction
var $b942167f74a67fc6$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $b942167f74a67fc6$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split("-")[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $b942167f74a67fc6$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? "bottom" : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? "bottom" : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $hLNJv.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? "div" : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $9s0WO.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $9s0WO.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn;
    var tooltipPosition = position === "mouse" ? mousePosition : position;
    var onShowHandler = (0, $4KkzB.usePlatformLeafSyntheticEventHandler)($b942167f74a67fc6$var$_objectSpread({
        fn: onShow,
        action: "displayed",
        analyticsData: analyticsContext
    }, $b942167f74a67fc6$var$analyticsAttributes));
    var onHideHandler = (0, $4KkzB.usePlatformLeafSyntheticEventHandler)($b942167f74a67fc6$var$_objectSpread({
        fn: onHide,
        action: "hidden",
        analyticsData: analyticsContext
    }, $b942167f74a67fc6$var$analyticsAttributes));
    var apiRef = (0, $iSvIT.useRef)(null);
    var _useState = (0, $iSvIT.useState)("hide"), _useState2 = (0, $jAOBB.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $iSvIT.useRef)(null);
    var containerRef = (0, $iSvIT.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $iSvIT.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $17fqS.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $17fqS.default)(onShowHandler);
    var onHideHandlerStable = (0, $17fqS.default)(onHideHandler);
    var delayStable = (0, $17fqS.default)(delay);
    var canAppearStable = (0, $17fqS.default)(canAppear);
    var hasCalledShowHandler = (0, $iSvIT.useRef)(false);
    var start = (0, $iSvIT.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $iSvIT.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState("hide");
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $iSvIT.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $iSvIT.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $iSvIT.useRef)(false);
    (0, $iSvIT.useEffect)(function() {
        return (0, $8mvDM.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $iSvIT.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? "show-immediate" : "fade-in");
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState("hide");
                else setState("before-fade-out");
            },
            done: done
        };
        var api = (0, $i7NIt.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    var hideTooltipOnEsc = (0, $iSvIT.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $2MOBR.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === "hide" || state === "fade-out"
    });
    (0, $iSvIT.useEffect)(function() {
        if (state === "hide") return 0, $9s0WO.default;
        if (state === "before-fade-out") setState("fade-out");
        var unbind = (0, $2e1kT.bind)(window, {
            type: "scroll",
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $iSvIT.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $iSvIT.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $iSvIT.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === "mouse" ? {
            type: "mouse",
            // TODO: ideally not recalculating this object each time
            mouse: (0, $9Cyew.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: "keyboard"
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $iSvIT.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === "mouse" ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $9Cyew.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $iSvIT.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $iSvIT.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(":focus-visible") && (0, $jxLBU.fg)("platform-tooltip-focus-visible-new")) return;
        } catch (_) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: "keyboard"
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $iSvIT.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $iSvIT.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === "exiting" && stableState.current === "fade-out" && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== "hide" && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== "hide" && state !== "fade-out";
    var handleOpenLayerObserverCloseSignal = (0, $iSvIT.useCallback)(function() {
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $1Z36a.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current5;
        if (position === "mouse" && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePosition) {
            var _apiRef$current6;
            return (_apiRef$current6 = apiRef.current) === null || _apiRef$current6 === void 0 ? void 0 : _apiRef$current6.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $7aTue.default)("tooltip", shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps["data-testid"] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === "function";
    (0, $iSvIT.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute("aria-describedby", tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute("aria-describedby");
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === "function" ? content({}) : content) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, typeof children === "function" ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, children($b942167f74a67fc6$var$_objectSpread($b942167f74a67fc6$var$_objectSpread({}, tooltipTriggerProps), {}, {
        "aria-describedby": tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(CastTargetContainer, (0, $ccHRj.default)({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $gWVOm.default), {
        zIndex: $b942167f74a67fc6$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $gr749.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === "mouse" ? undefined : $b942167f74a67fc6$var$invertedDirection[$b942167f74a67fc6$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iy0QV.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $g2f6i.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== "show-immediate" ? "medium" : "none"
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $b942167f74a67fc6$var$_objectSpread($b942167f74a67fc6$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: "none"
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === "function" ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $b942167f74a67fc6$export$2e2bcd8739ae039 = $b942167f74a67fc6$var$Tooltip;

});
parcelRegister("azswa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b234b4eff189151$export$2e2bcd8739ae039; });

var $15bF0 = parcelRequire("15bF0");
function $7b234b4eff189151$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $15bF0.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("15bF0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c9f4d961bbb4702$export$2e2bcd8739ae039; });

var $leMbb = parcelRequire("leMbb");

var $7B2oO = parcelRequire("7B2oO");
function $0c9f4d961bbb4702$export$2e2bcd8739ae039(t) {
    var i = (0, $7B2oO.default)(t, "string");
    return "symbol" == (0, $leMbb.default)(i) ? i : i + "";
}

});
parcelRegister("leMbb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7604733263baf6f$export$2e2bcd8739ae039; });
function $f7604733263baf6f$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $f7604733263baf6f$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f7604733263baf6f$export$2e2bcd8739ae039(o);
}

});

parcelRegister("7B2oO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $587dd98bff226251$export$2e2bcd8739ae039; });

var $leMbb = parcelRequire("leMbb");
function $587dd98bff226251$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $leMbb.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $leMbb.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("4KkzB", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $374b6abc0b735ad0$export$1a04351537078b55; });

var $azswa = parcelRequire("azswa");

var $iSvIT = parcelRequire("iSvIT");

var $izPhj = parcelRequire("izPhj");

var $1qAXJ = parcelRequire("1qAXJ");
function $374b6abc0b735ad0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $374b6abc0b735ad0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $374b6abc0b735ad0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $azswa.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $374b6abc0b735ad0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $374b6abc0b735ad0$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $izPhj.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $1qAXJ.useTrackedRef)(analyticsData);
    var fnRef = (0, $1qAXJ.useTrackedRef)(fn);
    var handler = (0, $iSvIT.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $374b6abc0b735ad0$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("izPhj", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $d86345a72fb4c00b$export$5bf35293e545f20c; });

var $6LIwV = parcelRequire("6LIwV");

var $biNIg = parcelRequire("biNIg");

var $3elzT = parcelRequire("3elzT");
function $d86345a72fb4c00b$export$5bf35293e545f20c() {
    var analyticsContext = (0, $3elzT.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $6LIwV.useCallbackOne)(function(payload) {
        return new (0, $biNIg.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("biNIg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83a7f019715ec854$export$2e2bcd8739ae039; });

var $1TiMA = parcelRequire("1TiMA");

var $hjsZv = parcelRequire("hjsZv");

var $a6ith = parcelRequire("a6ith");

var $gWdTl = parcelRequire("gWdTl");

var $3SmEH = parcelRequire("3SmEH");

var $5UaVX = parcelRequire("5UaVX");

var $91IBP = parcelRequire("91IBP");

var $azswa = parcelRequire("azswa");

var $k8ZTj = parcelRequire("k8ZTj");
function $83a7f019715ec854$var$_callSuper(t, o, e) {
    return o = (0, $3SmEH.default)(o), (0, $gWdTl.default)(t, $83a7f019715ec854$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $3SmEH.default)(t).constructor) : o.apply(t, e));
}
function $83a7f019715ec854$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($83a7f019715ec854$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $83a7f019715ec854$var$_superPropGet(t, o, e, r) {
    var p = (0, $5UaVX.default)((0, $3SmEH.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $83a7f019715ec854$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $83a7f019715ec854$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $83a7f019715ec854$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $hjsZv.default)(this, UIAnalyticsEvent);
        _this = $83a7f019715ec854$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $azswa.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $azswa.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $1TiMA.default)(_this.context);
            var handlers = (0, $1TiMA.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $azswa.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $91IBP.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $a6ith.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $83a7f019715ec854$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $k8ZTj.default));

});
parcelRegister("1TiMA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16097f57dd173376$export$2e2bcd8739ae039; });

var $jKbLQ = parcelRequire("jKbLQ");

var $4ZK9Q = parcelRequire("4ZK9Q");

var $6kZZ4 = parcelRequire("6kZZ4");

var $c96Mu = parcelRequire("c96Mu");
function $16097f57dd173376$export$2e2bcd8739ae039(r) {
    return (0, $jKbLQ.default)(r) || (0, $4ZK9Q.default)(r) || (0, $6kZZ4.default)(r) || (0, $c96Mu.default)();
}

});
parcelRegister("jKbLQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5fb71a20a75159a$export$2e2bcd8739ae039; });

var $bySJ9 = parcelRequire("bySJ9");
function $e5fb71a20a75159a$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $bySJ9.default)(r);
}

});

parcelRegister("4ZK9Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a30a9e2b9259299$export$2e2bcd8739ae039; });
function $3a30a9e2b9259299$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("c96Mu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d7b95e3fd302e0c$export$2e2bcd8739ae039; });
function $8d7b95e3fd302e0c$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("hjsZv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9aab30a1383ccdf$export$2e2bcd8739ae039; });
function $c9aab30a1383ccdf$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("a6ith", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75a8cae9fd541de7$export$2e2bcd8739ae039; });

var $15bF0 = parcelRequire("15bF0");
function $75a8cae9fd541de7$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $15bF0.default)(o.key), o);
    }
}
function $75a8cae9fd541de7$export$2e2bcd8739ae039(e, r, t) {
    return r && $75a8cae9fd541de7$var$_defineProperties(e.prototype, r), t && $75a8cae9fd541de7$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("gWdTl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c54cd6b5f90759b3$export$2e2bcd8739ae039; });

var $leMbb = parcelRequire("leMbb");

var $7KLeC = parcelRequire("7KLeC");
function $c54cd6b5f90759b3$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $leMbb.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $7KLeC.default)(t);
}

});
parcelRegister("7KLeC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a517823d18fd860$export$2e2bcd8739ae039; });
function $5a517823d18fd860$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("3SmEH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d27fd21fe41e4e1$export$2e2bcd8739ae039; });
function $2d27fd21fe41e4e1$export$2e2bcd8739ae039(t) {
    return $2d27fd21fe41e4e1$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $2d27fd21fe41e4e1$export$2e2bcd8739ae039(t);
}

});

parcelRegister("5UaVX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44caa9ebccbc59fc$export$2e2bcd8739ae039; });

var $eTzXC = parcelRequire("eTzXC");
function $44caa9ebccbc59fc$export$2e2bcd8739ae039() {
    return $44caa9ebccbc59fc$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $eTzXC.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $44caa9ebccbc59fc$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("eTzXC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad8218c81fbeb4aa$export$2e2bcd8739ae039; });

var $3SmEH = parcelRequire("3SmEH");
function $ad8218c81fbeb4aa$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $3SmEH.default)(t)););
    return t;
}

});


parcelRegister("91IBP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6926cf79a3cb682a$export$2e2bcd8739ae039; });

var $feQeo = parcelRequire("feQeo");
function $6926cf79a3cb682a$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $feQeo.default)(t, e);
}

});
parcelRegister("feQeo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b180adda08e52c57$export$2e2bcd8739ae039; });
function $b180adda08e52c57$export$2e2bcd8739ae039(t, e) {
    return $b180adda08e52c57$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $b180adda08e52c57$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("k8ZTj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eaa49045e3eb741c$export$2e2bcd8739ae039; });

var $leMbb = parcelRequire("leMbb");

var $hjsZv = parcelRequire("hjsZv");

var $a6ith = parcelRequire("a6ith");

var $azswa = parcelRequire("azswa");
function $eaa49045e3eb741c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eaa49045e3eb741c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eaa49045e3eb741c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $azswa.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eaa49045e3eb741c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $eaa49045e3eb741c$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $eaa49045e3eb741c$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $eaa49045e3eb741c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $hjsZv.default)(this, AnalyticsEvent);
        (0, $azswa.default)(this, "_isAnalyticsEvent", true);
        (0, $azswa.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $eaa49045e3eb741c$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $a6ith.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, $leMbb.default)(updater) === "object") this.payload = $eaa49045e3eb741c$var$_objectSpread($eaa49045e3eb741c$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("3elzT", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $25a36ad419f6ecd0$export$d1f587f82ad51c4; });

var $iSvIT = parcelRequire("iSvIT");

var $lEO1D = parcelRequire("lEO1D");
var $25a36ad419f6ecd0$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $iSvIT.useContext)((0, $lEO1D.default));
};

});


parcelRegister("1qAXJ", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $10a4e4227141c881$export$1d27a74659855e44; });

var $iSvIT = parcelRequire("iSvIT");
var $10a4e4227141c881$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $iSvIT.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("9s0WO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e1776bd6076f4b8$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $6e1776bd6076f4b8$export$2e2bcd8739ae039() {}

});

parcelRegister("2MOBR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20775279d9fca2ad$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $jxLBU = parcelRequire("jxLBU");

var $hq7Vu = parcelRequire("hq7Vu");
function $20775279d9fca2ad$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $iSvIT.useRef)(false);
    var onKeyDown = (0, $iSvIT.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $hq7Vu.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $iSvIT.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $iSvIT.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled && (0, $jxLBU.fg)("platform_only_attach_escape_handler_on_view")) return;
        return (0, $2e1kT.bindAll)(document, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
parcelRegister("hq7Vu", function(module, exports) {

$parcel$export(module.exports, "ESCAPE", function () { return $caeb0356e18f4e6c$export$2bb790b9008907b4; });
/**
 * Character key codes which can be used in keyboard events.
 */ var $caeb0356e18f4e6c$export$390330c10ff2b9a1 = "ArrowUp";
var $caeb0356e18f4e6c$export$a80636c6f41931fe = "ArrowDown";
var $caeb0356e18f4e6c$export$4af703091671bc = "Home";
var $caeb0356e18f4e6c$export$e2bc30913faa5db7 = "End";
var $caeb0356e18f4e6c$export$10f6869ed0a7d75b = "Tab";
var $caeb0356e18f4e6c$export$8152f929a25a0ff4 = "Enter";
var $caeb0356e18f4e6c$export$e51a3576c045c8d5 = "Space";
var $caeb0356e18f4e6c$export$2bb790b9008907b4 = "Escape";

});


parcelRegister("17fqS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d026a7243df3826$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
function $0d026a7243df3826$export$2e2bcd8739ae039(value) {
    var ref = (0, $iSvIT.useRef)(value);
    (0, $iSvIT.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("12inm", function(module, exports) {

$parcel$export(module.exports, "layers", function () { return $0c143b609d8111b6$export$7be255094ccdc533; });

var $hgcBA = parcelRequire("hgcBA");

var $ej788 = parcelRequire("ej788");
var $0c143b609d8111b6$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $0c143b609d8111b6$export$c93026a968943f95 = "light";
var $0c143b609d8111b6$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $0c143b609d8111b6$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $0c143b609d8111b6$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $0c143b609d8111b6$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $ej788.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $0c143b609d8111b6$export$6d8204c2cb2e06b8() / 4;
    (0, $hgcBA.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $0c143b609d8111b6$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $0c143b609d8111b6$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $0c143b609d8111b6$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $hgcBA.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $0c143b609d8111b6$export$ba1d834b86d72a09 = $0c143b609d8111b6$export$a1b3edb637fb4f35;
var $0c143b609d8111b6$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $ej788.N20A), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $ej788.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $ej788.N30A), ")")
            }
        }
    };
};

});
parcelRegister("hgcBA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $033e28166683ed93$export$2e2bcd8739ae039; });

var $jMhob = parcelRequire("jMhob");

var $XAEGR = parcelRequire("XAEGR");
function $033e28166683ed93$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $jMhob.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $033e28166683ed93$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $XAEGR;
}

});
parcelRegister("jMhob", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e65ffd1d5918886f$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $e65ffd1d5918886f$var$printed = {};
function $e65ffd1d5918886f$export$2e2bcd8739ae039(message) {
    if ($e65ffd1d5918886f$var$printed[message]) return;
    $e65ffd1d5918886f$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}

});


parcelRegister("ej788", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $a6a85ef6d8578e14$export$215b7063051591f1; });
$parcel$export(module.exports, "N0", function () { return $a6a85ef6d8578e14$export$29a4f05edc054374; });
$parcel$export(module.exports, "N800", function () { return $a6a85ef6d8578e14$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $a6a85ef6d8578e14$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $a6a85ef6d8578e14$export$920c0d5c49070351; });
// Reds
var $a6a85ef6d8578e14$export$4b84fd0e2c617bd = "#FFEBE6";
var $a6a85ef6d8578e14$export$b34b069eff244586 = "#FFBDAD";
var $a6a85ef6d8578e14$export$be802dd0d8b57f35 = "#FF8F73";
var $a6a85ef6d8578e14$export$60847d42f9da92a6 = "#FF7452";
var $a6a85ef6d8578e14$export$4a7404f376229999 = "#FF5630";
var $a6a85ef6d8578e14$export$2010d0fb4295b346 = "#DE350B";
var $a6a85ef6d8578e14$export$2837b5a1a71d5c02 = "#BF2600";
var $a6a85ef6d8578e14$export$8d9596b529bbb9cf = "#FFFAE6";
var $a6a85ef6d8578e14$export$41060a744ab0b7ae = "#FFF0B3";
var $a6a85ef6d8578e14$export$1cc05bbbf340e559 = "#FFE380";
var $a6a85ef6d8578e14$export$5aae31392d72caaa = "#FFC400";
var $a6a85ef6d8578e14$export$c6930421db9fa514 = "#FFAB00";
var $a6a85ef6d8578e14$export$59619663aa6500fb = "#FF991F";
var $a6a85ef6d8578e14$export$874739ea9e379ab6 = "#FF8B00";
var $a6a85ef6d8578e14$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $a6a85ef6d8578e14$export$69a3bf21b9686c2b = "#ABF5D1";
var $a6a85ef6d8578e14$export$afbce1382ec95f73 = "#79F2C0";
var $a6a85ef6d8578e14$export$747d86715d4175de = "#57D9A3";
var $a6a85ef6d8578e14$export$940e1f69e873f202 = "#36B37E";
var $a6a85ef6d8578e14$export$a49394138f7b8e85 = "#00875A";
var $a6a85ef6d8578e14$export$6fa04827ac68a4fb = "#006644";
var $a6a85ef6d8578e14$export$226de0355ed012f8 = "#DEEBFF";
var $a6a85ef6d8578e14$export$8c13c2ee36917869 = "#B3D4FF";
var $a6a85ef6d8578e14$export$ecfc1dff386a3e7a = "#4C9AFF";
var $a6a85ef6d8578e14$export$215b7063051591f1 = "#2684FF";
var $a6a85ef6d8578e14$export$e62e8919cca44969 = "#0065FF";
var $a6a85ef6d8578e14$export$b3de0ae08da2ce64 = "#0052CC";
var $a6a85ef6d8578e14$export$a6ee3d71bc067634 = "#0747A6";
var $a6a85ef6d8578e14$export$67f15409e87642a1 = "#669DF1";
var $a6a85ef6d8578e14$export$f0539dbc42dbb067 = "#8FB8F6";
var $a6a85ef6d8578e14$export$363e4475840015bb = "#EAE6FF";
var $a6a85ef6d8578e14$export$4b0a4417ed59760f = "#C0B6F2";
var $a6a85ef6d8578e14$export$6011520a64d9a187 = "#998DD9";
var $a6a85ef6d8578e14$export$a7175d4e9206bc80 = "#8777D9";
var $a6a85ef6d8578e14$export$b48405b95304b5a1 = "#6554C0";
var $a6a85ef6d8578e14$export$c71e4279dd54a18d = "#5243AA";
var $a6a85ef6d8578e14$export$147899de772240ec = "#403294";
var $a6a85ef6d8578e14$export$2cf711fe14c66f06 = "#E6FCFF";
var $a6a85ef6d8578e14$export$7a8f4d33f6f9772c = "#B3F5FF";
var $a6a85ef6d8578e14$export$776c9c497ef08533 = "#79E2F2";
var $a6a85ef6d8578e14$export$69cb3ca10c1e330e = "#00C7E6";
var $a6a85ef6d8578e14$export$9dc1ef0f3f48059b = "#00B8D9";
var $a6a85ef6d8578e14$export$7c835c78b6fcdef8 = "#00A3BF";
var $a6a85ef6d8578e14$export$6036577f95c3877e = "#008DA6";
var $a6a85ef6d8578e14$export$29a4f05edc054374 = "#FFFFFF";
var $a6a85ef6d8578e14$export$e655ef011c4aa1a2 = "#FAFBFC";
var $a6a85ef6d8578e14$export$9fdfb749e33cdf97 = "#F4F5F7";
var $a6a85ef6d8578e14$export$3e51e8f1440314ba = "#EBECF0";
var $a6a85ef6d8578e14$export$1ce2d1575d444ceb = "#DFE1E6";
var $a6a85ef6d8578e14$export$8754fc7e6d8b3000 = "#C1C7D0";
var $a6a85ef6d8578e14$export$c2e91cbeada39b8b = "#B3BAC5";
var $a6a85ef6d8578e14$export$5f71e19f3a7ad9de = "#A5ADBA";
var $a6a85ef6d8578e14$export$eaa8c8a70ac22806 = "#97A0AF";
var $a6a85ef6d8578e14$export$7c87d337fb91a97d = "#8993A4";
var $a6a85ef6d8578e14$export$d6447c357493214f = "#7A869A";
var $a6a85ef6d8578e14$export$f563ee71e9ee74cd = "#6B778C";
var $a6a85ef6d8578e14$export$e2ef2124cf4024b1 = "#5E6C84";
var $a6a85ef6d8578e14$export$eece5f492e429f08 = "#505F79";
var $a6a85ef6d8578e14$export$c39c0fe0f26207ae = "#42526E";
var $a6a85ef6d8578e14$export$7090862dc3038a9f = "#344563";
var $a6a85ef6d8578e14$export$ad0bacf983b7ddaa = "#253858";
var $a6a85ef6d8578e14$export$7d61b15e0da132af = "#172B4D";
var $a6a85ef6d8578e14$export$fbda843f0a27fe96 = "#091E42";
var $a6a85ef6d8578e14$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $a6a85ef6d8578e14$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $a6a85ef6d8578e14$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $a6a85ef6d8578e14$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $a6a85ef6d8578e14$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $a6a85ef6d8578e14$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $a6a85ef6d8578e14$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $a6a85ef6d8578e14$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $a6a85ef6d8578e14$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $a6a85ef6d8578e14$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $a6a85ef6d8578e14$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $a6a85ef6d8578e14$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $a6a85ef6d8578e14$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $a6a85ef6d8578e14$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $a6a85ef6d8578e14$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $a6a85ef6d8578e14$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $a6a85ef6d8578e14$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $a6a85ef6d8578e14$export$2f6319cf7d736c2a = "#E6EDFA";
var $a6a85ef6d8578e14$export$95126bc8884d6634 = "#DCE5F5";
var $a6a85ef6d8578e14$export$8338d8c35d44ff1 = "#CED9EB";
var $a6a85ef6d8578e14$export$5368d76ae4fbbda7 = "#B8C7E0";
var $a6a85ef6d8578e14$export$9f0a771d16ec8d36 = "#ABBBD6";
var $a6a85ef6d8578e14$export$abcf8c38338b4aa5 = "#9FB0CC";
var $a6a85ef6d8578e14$export$97e81faa16a182c7 = "#8C9CB8";
var $a6a85ef6d8578e14$export$bfe21c59123ecf33 = "#7988A3";
var $a6a85ef6d8578e14$export$ee82aa2ea6a1558 = "#67758F";
var $a6a85ef6d8578e14$export$682927c6ed76be02 = "#56637A";
var $a6a85ef6d8578e14$export$91fd9994c5be9757 = "#455166";
var $a6a85ef6d8578e14$export$d281fbfe3cff2df6 = "#3B475C";
var $a6a85ef6d8578e14$export$3902c91d8b98a753 = "#313D52";
var $a6a85ef6d8578e14$export$8e8133c1ba5845b5 = "#283447";
var $a6a85ef6d8578e14$export$33ff357f6620b39 = "#202B3D";
var $a6a85ef6d8578e14$export$633847cf062b69e0 = "#1B2638";
var $a6a85ef6d8578e14$export$9776a6e503bdbf76 = "#121A29";
var $a6a85ef6d8578e14$export$6c813d5160dff5db = "#0E1624";
var $a6a85ef6d8578e14$export$3d4f271a500072a = "#0D1424";
var $a6a85ef6d8578e14$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $a6a85ef6d8578e14$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $a6a85ef6d8578e14$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $a6a85ef6d8578e14$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $a6a85ef6d8578e14$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $a6a85ef6d8578e14$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $a6a85ef6d8578e14$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $a6a85ef6d8578e14$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $a6a85ef6d8578e14$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $a6a85ef6d8578e14$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $a6a85ef6d8578e14$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $a6a85ef6d8578e14$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $a6a85ef6d8578e14$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $a6a85ef6d8578e14$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $a6a85ef6d8578e14$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $a6a85ef6d8578e14$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $a6a85ef6d8578e14$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $a6a85ef6d8578e14$export$d2adc5dedf09fced = "#292A2E";
var $a6a85ef6d8578e14$export$f51762073d2bb381 = "#94C748";
var $a6a85ef6d8578e14$export$95e26d54def96891 = "#B3DF72";

});


parcelRegister("8mvDM", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $6168ebfcb2d585e6$export$6503ec6e8aabbaf; });
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $2e1kT = parcelRequire("2e1kT");
var $6168ebfcb2d585e6$var$registrations = new Set();
var $6168ebfcb2d585e6$var$cleanupEndEventListeners = null;
function $6168ebfcb2d585e6$var$onDragStart() {
    if ($6168ebfcb2d585e6$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $6168ebfcb2d585e6$var$cleanupEndEventListeners = (0, $2e1kT.bindAll)(window, [
        {
            type: "dragend",
            listener: $6168ebfcb2d585e6$var$onDragEnd
        },
        {
            type: "pointerdown",
            listener: $6168ebfcb2d585e6$var$onDragEnd
        },
        {
            type: "pointermove",
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $6168ebfcb2d585e6$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($6168ebfcb2d585e6$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $6168ebfcb2d585e6$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $6168ebfcb2d585e6$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $6168ebfcb2d585e6$var$cleanupEndEventListeners = null;
    var clone = Array.from($6168ebfcb2d585e6$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $6168ebfcb2d585e6$var$bindStartEvents() {
    return (0, $2e1kT.bindAll)(window, [
        {
            type: "dragstart",
            listener: $6168ebfcb2d585e6$var$onDragStart
        },
        {
            type: "dragenter",
            listener: $6168ebfcb2d585e6$var$onDragStart
        }
    ]);
}
var $6168ebfcb2d585e6$var$cleanupStartEventListeners = null;
function $6168ebfcb2d585e6$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$6168ebfcb2d585e6$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $6168ebfcb2d585e6$var$cleanupStartEventListeners = $6168ebfcb2d585e6$var$bindStartEvents();
    $6168ebfcb2d585e6$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $6168ebfcb2d585e6$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $6168ebfcb2d585e6$var$registrations.delete(registration);
        if ($6168ebfcb2d585e6$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $6168ebfcb2d585e6$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $6168ebfcb2d585e6$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("i7NIt", function(module, exports) {

$parcel$export(module.exports, "show", function () { return $d31f720c2075ec1b$export$57bf213be019eeb0; });

var $lDaEa = parcelRequire("lDaEa");
// This file is a singleton for managing tooltips
var $d31f720c2075ec1b$var$active = null;
function $d31f720c2075ec1b$export$57bf213be019eeb0(entry) {
    var phase = "waiting-to-show";
    function isActive() {
        return Boolean($d31f720c2075ec1b$var$active && $d31f720c2075ec1b$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $lDaEa.clearScheduled)();
            $d31f720c2075ec1b$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = "done";
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === "waiting-to-hide") {
            phase = "shown";
            (0, $lDaEa.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === "hide-animating") {
            phase = "shown";
            (0, $lDaEa.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === "waiting-to-show") {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === "waiting-to-hide") return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = "waiting-to-hide";
        (0, $lDaEa.scheduleTimeout)(function() {
            phase = "hide-animating";
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === "hide-animating") done();
    }
    function isVisible() {
        return phase === "shown" || phase === "waiting-to-hide" || phase === "hide-animating";
    }
    function getInitialMouse() {
        if (entry.source.type === "mouse") return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($d31f720c2075ec1b$var$active && $d31f720c2075ec1b$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($d31f720c2075ec1b$var$active) {
            (0, $lDaEa.clearScheduled)();
            $d31f720c2075ec1b$var$active.entry.hide({
                isImmediate: true
            });
            $d31f720c2075ec1b$var$active.entry.done();
            $d31f720c2075ec1b$var$active = null;
        }
        // this tooltip is now the active tooltip
        $d31f720c2075ec1b$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = "shown";
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = "waiting-to-show";
        (0, $lDaEa.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("lDaEa", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", function () { return $fbf57fc08d905be0$export$eaf678f6f93f5250; });
$parcel$export(module.exports, "scheduleTimeout", function () { return $fbf57fc08d905be0$export$5f4d6617421d489b; });
var $fbf57fc08d905be0$var$delayId = null;
function $fbf57fc08d905be0$export$eaf678f6f93f5250() {
    if ($fbf57fc08d905be0$var$delayId != null) {
        window.clearTimeout($fbf57fc08d905be0$var$delayId);
        $fbf57fc08d905be0$var$delayId = null;
    }
}
function $fbf57fc08d905be0$export$5f4d6617421d489b(fn, delay) {
    $fbf57fc08d905be0$export$eaf678f6f93f5250();
    $fbf57fc08d905be0$var$delayId = window.setTimeout(function() {
        $fbf57fc08d905be0$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("7aTue", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53948209b686c355$export$2e2bcd8739ae039; });

var $9j7Yj = parcelRequire("9j7Yj");
function $53948209b686c355$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $9j7Yj.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});
parcelRegister("9j7Yj", function(module, exports) {

$parcel$export(module.exports, "useIdSeed", function () { return $6c6c1268eaa68b7c$export$6ee17796e3d70de2; });

var $leMbb = parcelRequire("leMbb");

var $iSvIT = parcelRequire("iSvIT");

var $lzzak = parcelRequire("lzzak");

var $jxLBU = parcelRequire("jxLBU");
var $6c6c1268eaa68b7c$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $6c6c1268eaa68b7c$var$react18UseId = ($6c6c1268eaa68b7c$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useId) !== null && $6c6c1268eaa68b7c$var$_React$useId !== void 0 ? $6c6c1268eaa68b7c$var$_React$useId : undefined;
function $6c6c1268eaa68b7c$export$f680877a34711e37() {
    if ($6c6c1268eaa68b7c$var$react18UseId && (0, $jxLBU.fg)("platform-dst-react-18-use-id")) return $6c6c1268eaa68b7c$var$react18UseId();
    return "uid".concat((0, $lzzak.useUID)());
}
var $6c6c1268eaa68b7c$export$6be90bcb437e928f = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($6c6c1268eaa68b7c$export$f680877a34711e37()).concat(postfix);
    (0, $iSvIT.useEffect)(function() {
        if (!ref) return;
        switch((0, $leMbb.default)(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, $leMbb.default)(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $6c6c1268eaa68b7c$export$6ee17796e3d70de2() {
    if ($6c6c1268eaa68b7c$var$react18UseId && (0, $jxLBU.fg)("platform-dst-react-18-use-id")) {
        var uid = $6c6c1268eaa68b7c$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $lzzak.useUIDSeed)();
}

});


parcelRegister("hLNJv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cefd6765f6460a4a$export$2e2bcd8739ae039; });
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $azswa = parcelRequire("azswa");

var $iSvIT = parcelRequire("iSvIT");

var $fDVJn = parcelRequire("fDVJn");
var $kv9H0 = parcelRequire("kv9H0");

var $ej788 = parcelRequire("ej788");

var $gcbix = parcelRequire("gcbix");
function $cefd6765f6460a4a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cefd6765f6460a4a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cefd6765f6460a4a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $azswa.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cefd6765f6460a4a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cefd6765f6460a4a$var$baseStyles = null;
var $cefd6765f6460a4a$var$truncateStyles = null;
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $cefd6765f6460a4a$var$TooltipContainer = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $iSvIT.createElement((0, $gcbix.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $fDVJn.default)([
            "_2rko1sit _11c8dcr7 _vchhusvi _p12fp3fh _bfhkpioe _syaz1i9p _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
            truncate && "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c",
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        style: $cefd6765f6460a4a$var$_objectSpread($cefd6765f6460a4a$var$_objectSpread({}, style), {}, {
            "--_yr7xfv": (0, $kv9H0.default)("var(--ds-background-neutral-bold, ".concat((0, $ej788.N800), ")")),
            "--_ywovvi": (0, $kv9H0.default)("var(--ds-text-inverse, ".concat((0, $ej788.N0), ")"))
        })
    }, children);
});
$cefd6765f6460a4a$var$TooltipContainer.displayName = "TooltipContainer";
var $cefd6765f6460a4a$export$2e2bcd8739ae039 = $cefd6765f6460a4a$var$TooltipContainer;

});
parcelRegister("kv9H0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eece38a6a8e4d3a9$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $eece38a6a8e4d3a9$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return "var(--c-, )";
}

});

parcelRegister("gcbix", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bca687e0c2ca3225$export$2e2bcd8739ae039; });
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $fDVJn = parcelRequire("fDVJn");
var $bca687e0c2ca3225$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $bca687e0c2ca3225$var$TooltipPrimitive = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $iSvIT.createElement("div", {
        role: "tooltip",
        className: (0, $fDVJn.default)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$bca687e0c2ca3225$var$TooltipPrimitive.displayName = "TooltipPrimitive";
var $bca687e0c2ca3225$export$2e2bcd8739ae039 = $bca687e0c2ca3225$var$TooltipPrimitive;

});


parcelRegister("9Cyew", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", function () { return $701237b0ac6a41b3$export$642213d516a9b928; });
function $701237b0ac6a41b3$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("4PIYf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $384ecf1efce518b6$export$2e2bcd8739ae039; });
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden

var $iSvIT = parcelRequire("iSvIT");

var $aaxSj = parcelRequire("aaxSj");
var $384ecf1efce518b6$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $384ecf1efce518b6$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $aaxSj.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c"
        ])
    }, children);
};
var $384ecf1efce518b6$export$2e2bcd8739ae039 = $384ecf1efce518b6$var$VisuallyHidden;

});
parcelRegister("aaxSj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76751d7005d0ce4d$export$2e2bcd8739ae039; });
const $76751d7005d0ce4d$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $76751d7005d0ce4d$var$ATOMIC_GROUP_LENGTH = 5;
function $76751d7005d0ce4d$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $76751d7005d0ce4d$var$UNDERSCORE_UNICODE ? $76751d7005d0ce4d$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});


parcelRegister("10Awm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bc21ed26a3d8bfa$export$2e2bcd8739ae039; });
/* button-base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $ccHRj = parcelRequire("ccHRj");

var $8ymlm = parcelRequire("8ymlm");

var $fDVJn = parcelRequire("fDVJn");

var $iSvIT = parcelRequire("iSvIT");

var $7Arze = parcelRequire("7Arze");

var $kBwex = parcelRequire("kBwex");

var $2asUG = parcelRequire("2asUG");

var $6nkOk = parcelRequire("6nkOk");

var $jxLBU = parcelRequire("jxLBU");

var $1IQkj = parcelRequire("1IQkj");

var $4PIYf = parcelRequire("4PIYf");

var $b4z5H = parcelRequire("b4z5H");

var $5utuA = parcelRequire("5utuA");

var $i4o09 = parcelRequire("i4o09");
var $0bc21ed26a3d8bfa$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $0bc21ed26a3d8bfa$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $0bc21ed26a3d8bfa$var$LOADING_LABEL = ", Loading";
var $0bc21ed26a3d8bfa$var$styles = {
    base: "_2rkosqtm _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1lh4 _30l31lh4 _9h8h1lh4",
    sharedDisabled: "_bfhk1fvb _irr31fvb _1di61fvb",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    circle: "_2rko14q2",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $0bc21ed26a3d8bfa$var$defaultStyles = {
    root: "_bfhk1j54 _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhksm61 _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr3yw9d _30l310s3 _1di6ih13 _9h8h10s3",
    interactiveRefreshed: "_irr3166n _30l31gjq _1di61dty _9h8h1gjq",
    disabledRefreshed: "_bfhk1j28 _8l3m13gt _irr31j28 _1di61j28"
};
var $0bc21ed26a3d8bfa$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $0bc21ed26a3d8bfa$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $0bc21ed26a3d8bfa$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $0bc21ed26a3d8bfa$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $0bc21ed26a3d8bfa$var$subtleStyles = {
    root: "_bfhkqtfy _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhkqtfy _syaz1gjq _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    interactiveRefreshed: "_irr34mfv _30l31gjq _1di619qy _9h8h1gjq",
    disabledRefreshed: "_bfhk1j28 _8l3m13gt _irr31j28 _1di61j28"
};
var $0bc21ed26a3d8bfa$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _30l31pke _9h8h1pke",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $0bc21ed26a3d8bfa$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function(_ref, ref) {
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? "default" : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, $8ymlm.default)(_ref, $0bc21ed26a3d8bfa$var$_excluded);
    var localRef = (0, $iSvIT.useRef)(null);
    var splitButtonContext = (0, $b4z5H.useSplitButtonContext)();
    var loadingLabelId = (0, $6nkOk.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === "default";
    var appearance = isDefaultAppearanceSplitButton && (0, $jxLBU.fg)("platform-component-visual-refresh") ? "subtle" : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || "default";
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $2asUG.default)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $8ymlm.default)(unsafeRest, $0bc21ed26a3d8bfa$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $1IQkj.default), (0, $ccHRj.default)({}, saferRest, {
        componentName: componentName || "button",
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $kBwex.default)([
            localRef,
            ref
        ]),
        xcss: (0, $7Arze.cx)($0bc21ed26a3d8bfa$var$styles.base, appearance === "default" && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $0bc21ed26a3d8bfa$var$defaultStyles.rootRefreshed : $0bc21ed26a3d8bfa$var$defaultStyles.root), appearance === "default" && isInteractive && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $0bc21ed26a3d8bfa$var$defaultStyles.interactiveRefreshed : $0bc21ed26a3d8bfa$var$defaultStyles.interactive), appearance === "primary" && $0bc21ed26a3d8bfa$var$primaryStyles.root, appearance === "primary" && isInteractive && $0bc21ed26a3d8bfa$var$primaryStyles.interactive, appearance === "warning" && $0bc21ed26a3d8bfa$var$warningStyles.root, appearance === "warning" && isInteractive && $0bc21ed26a3d8bfa$var$warningStyles.interactive, appearance === "danger" && $0bc21ed26a3d8bfa$var$dangerStyles.root, appearance === "danger" && isInteractive && $0bc21ed26a3d8bfa$var$dangerStyles.interactive, appearance === "discovery" && $0bc21ed26a3d8bfa$var$discoveryStyles.root, appearance === "discovery" && isInteractive && $0bc21ed26a3d8bfa$var$discoveryStyles.interactive, appearance === "subtle" && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $0bc21ed26a3d8bfa$var$subtleStyles.rootRefreshed : $0bc21ed26a3d8bfa$var$subtleStyles.root), appearance === "subtle" && isInteractive && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $0bc21ed26a3d8bfa$var$subtleStyles.interactiveRefreshed : $0bc21ed26a3d8bfa$var$subtleStyles.interactive), $0bc21ed26a3d8bfa$var$styles.linkDecorationUnset, isSelected && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $0bc21ed26a3d8bfa$var$selectedStyles.rootRefreshed : $0bc21ed26a3d8bfa$var$selectedStyles.root), isSelected && isSplitButton && $0bc21ed26a3d8bfa$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $0bc21ed26a3d8bfa$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "danger" && $0bc21ed26a3d8bfa$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "warning" && $0bc21ed26a3d8bfa$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "discovery" && $0bc21ed26a3d8bfa$var$selectedStyles.discovery, isDisabled && $0bc21ed26a3d8bfa$var$styles.disabled, isDisabled && (!(0, $jxLBU.fg)("platform-component-visual-refresh") || appearance !== "default" && appearance !== "subtle") && $0bc21ed26a3d8bfa$var$styles.sharedDisabled, isDisabled && appearance === "default" && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $0bc21ed26a3d8bfa$var$defaultStyles.disabledRefreshed : $0bc21ed26a3d8bfa$var$defaultStyles.disabled), isCircle && !isSplitButton && $0bc21ed26a3d8bfa$var$styles.circle, spacing === "compact" && $0bc21ed26a3d8bfa$var$styles.spacingCompact, hasIconBefore && $0bc21ed26a3d8bfa$var$styles.buttonIconBefore, shouldFitContainer && $0bc21ed26a3d8bfa$var$styles.fullWidth, hasIconAfter && $0bc21ed26a3d8bfa$var$styles.buttonIconAfter, isIconButton && $0bc21ed26a3d8bfa$var$styles.iconButton, isIconButton && spacing === "compact" && $0bc21ed26a3d8bfa$var$styles.iconButtonCompact, isLoading && $0bc21ed26a3d8bfa$var$styles.loading, isSplitButton && $0bc21ed26a3d8bfa$var$styles.splitButton, isNavigationSplitButton && $0bc21ed26a3d8bfa$var$styles.navigationSplitButton),
        isDisabled: isEffectivelyDisabled,
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($0bc21ed26a3d8bfa$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $5utuA.default)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $b4z5H.SplitButtonContext).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        className: (0, $fDVJn.default)([
            $0bc21ed26a3d8bfa$var$styles.loadingOverlay
        ])
    }, (0, $i4o09.default)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $4PIYf.default), {
        id: loadingLabelId
    }, $0bc21ed26a3d8bfa$var$LOADING_LABEL)));
});
var $0bc21ed26a3d8bfa$export$2e2bcd8739ae039 = $0bc21ed26a3d8bfa$var$ButtonBase;

});
parcelRegister("7Arze", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $5861477c18e0efc1$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("iSvIT");


var $7yn5t = parcelRequire("7yn5t");
var $5861477c18e0efc1$var$_createStrictAPI = (0, $7yn5t.createStrictAPI)(), $5861477c18e0efc1$var$XCSSProp = $5861477c18e0efc1$var$_createStrictAPI.XCSSProp, $5861477c18e0efc1$export$dbf350e5966cf602 = $5861477c18e0efc1$var$_createStrictAPI.css, $5861477c18e0efc1$export$eb1ecd84a24ee424 = $5861477c18e0efc1$var$_createStrictAPI.cssMap, $5861477c18e0efc1$export$a274e22fb40f762e = $5861477c18e0efc1$var$_createStrictAPI.cx;
 // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means products only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 
});
parcelRegister("7yn5t", function(module, exports) {

$parcel$export(module.exports, "createStrictAPI", function () { return $57fd9e0bd1c5f3d1$export$39716b4af53f4ad; });

var $ctICj = parcelRequire("ctICj");

var $f7vJ2 = parcelRequire("f7vJ2");
function $57fd9e0bd1c5f3d1$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $ctICj.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $ctICj.createStrictSetupError)();
        },
        cx: $f7vJ2.cx,
        XCSSProp () {
            throw (0, $ctICj.createStrictSetupError)();
        }
    };
}

});
parcelRegister("ctICj", function(module, exports) {

$parcel$export(module.exports, "createStrictSetupError", function () { return $915acd79ab01bdf0$export$c4df1cb0c2b4d77c; });
const $915acd79ab01bdf0$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $915acd79ab01bdf0$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("f7vJ2", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $b0201e77412a8009$export$a274e22fb40f762e; });

var $fDVJn = parcelRequire("fDVJn");
const $b0201e77412a8009$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $fDVJn.default)(actualStyles);
};

});



parcelRegister("2asUG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1942f183f9daab49$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
function $1942f183f9daab49$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $iSvIT.useRef)(true);
    (0, $iSvIT.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("6nkOk", function(module, exports) {

$parcel$export(module.exports, "useId", function () { return $4a45089da8cd5905$export$f680877a34711e37; });

var $leMbb = parcelRequire("leMbb");

var $iSvIT = parcelRequire("iSvIT");

var $lzzak = parcelRequire("lzzak");

var $jxLBU = parcelRequire("jxLBU");
var $4a45089da8cd5905$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $4a45089da8cd5905$var$react18UseId = ($4a45089da8cd5905$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useId) !== null && $4a45089da8cd5905$var$_React$useId !== void 0 ? $4a45089da8cd5905$var$_React$useId : undefined;
function $4a45089da8cd5905$export$f680877a34711e37() {
    if ($4a45089da8cd5905$var$react18UseId && (0, $jxLBU.fg)("platform-dst-react-18-use-id")) return $4a45089da8cd5905$var$react18UseId();
    return "uid".concat((0, $lzzak.useUID)());
}
var $4a45089da8cd5905$export$6be90bcb437e928f = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($4a45089da8cd5905$export$f680877a34711e37()).concat(postfix);
    (0, $iSvIT.useEffect)(function() {
        if (!ref) return;
        switch((0, $leMbb.default)(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, $leMbb.default)(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $4a45089da8cd5905$export$6ee17796e3d70de2() {
    if ($4a45089da8cd5905$var$react18UseId && (0, $jxLBU.fg)("platform-dst-react-18-use-id")) {
        var uid = $4a45089da8cd5905$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $lzzak.useUIDSeed)();
}

});

parcelRegister("1IQkj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14127d7e8d38e105$export$2e2bcd8739ae039; });
/* pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $ccHRj = parcelRequire("ccHRj");

var $8ymlm = parcelRequire("8ymlm");

var $iSvIT = parcelRequire("iSvIT");


var $f7vJ2 = parcelRequire("f7vJ2");

var $dveoQ = parcelRequire("dveoQ");

var $eTwXf = parcelRequire("eTwXf");

var $239kt = parcelRequire("239kt");

var $7nG8r = parcelRequire("7nG8r");

var $3Xx1D = parcelRequire("3Xx1D");
var $14127d7e8d38e105$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $14127d7e8d38e105$var$_excluded2 = [
    "className"
];
var $14127d7e8d38e105$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $14127d7e8d38e105$var$Pressable = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $239kt.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, $8ymlm.default)(_ref, $14127d7e8d38e105$var$_excluded);
    var interactionContext = (0, $iSvIT.useContext)((0, $7nG8r.default));
    var handleClick = (0, $iSvIT.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $dveoQ.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "14.11.2",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $8ymlm.default)(htmlAttributes, $14127d7e8d38e105$var$_excluded2);
    return /*#__PURE__*/ $iSvIT.createElement((0, $3Xx1D.default), (0, $ccHRj.default)({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $eTwXf.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $f7vJ2.cx)($14127d7e8d38e105$var$styles.root, isDisabled && $14127d7e8d38e105$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $14127d7e8d38e105$export$2e2bcd8739ae039 = $14127d7e8d38e105$var$Pressable;

});
parcelRegister("dveoQ", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $9d495714c0930e95$export$a4687b0234b40e28; });

var $azswa = parcelRequire("azswa");

var $iSvIT = parcelRequire("iSvIT");

var $izPhj = parcelRequire("izPhj");

var $1qAXJ = parcelRequire("1qAXJ");
function $9d495714c0930e95$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9d495714c0930e95$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9d495714c0930e95$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $azswa.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9d495714c0930e95$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9d495714c0930e95$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $izPhj.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $1qAXJ.useTrackedRef)(analyticsData);
    var fnRef = (0, $1qAXJ.useTrackedRef)(fn);
    var handler = (0, $iSvIT.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $9d495714c0930e95$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("eTwXf", function(module, exports) {

$parcel$export(module.exports, "isSafari", function () { return $ad7fc3d5e943b343$export$95df08bae54cb4df; });
function $ad7fc3d5e943b343$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== "undefined" && window.navigator != null ? //@ts-expect-error ignore userAgentData type issue
    re.test(((_window$navigator$use = window.navigator["userAgentData"]) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $ad7fc3d5e943b343$var$isIPhone() {
    return $ad7fc3d5e943b343$var$testPlatform(/^iPhone/i);
}
function $ad7fc3d5e943b343$var$isMac() {
    return $ad7fc3d5e943b343$var$testPlatform(/^Mac/i);
}
function $ad7fc3d5e943b343$var$isIPad() {
    return $ad7fc3d5e943b343$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $ad7fc3d5e943b343$var$isMac() && navigator.maxTouchPoints > 1;
}
function $ad7fc3d5e943b343$var$isIOS() {
    return $ad7fc3d5e943b343$var$isIPhone() || $ad7fc3d5e943b343$var$isIPad();
}
function $ad7fc3d5e943b343$export$95df08bae54cb4df() {
    if (typeof window !== "undefined" && window.navigator != null) {
        var _window$navigator$use2;
        var ua = (_window$navigator$use2 = window.navigator.userAgent) === null || _window$navigator$use2 === void 0 ? void 0 : _window$navigator$use2.toLowerCase();
        return ua ? ua.includes("safari") && !ua.includes("chrome") : false;
    }
    return false;
}
function $ad7fc3d5e943b343$export$e1865c3bedcd822b() {
    return $ad7fc3d5e943b343$var$isMac() || $ad7fc3d5e943b343$var$isIOS();
}

});

parcelRegister("239kt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17e31927878433e7$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $17e31927878433e7$export$2e2bcd8739ae039() {}

});

parcelRegister("3Xx1D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e207fed0319cde5$export$2e2bcd8739ae039; });
/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $ccHRj = parcelRequire("ccHRj");

var $azswa = parcelRequire("azswa");

var $8ymlm = parcelRequire("8ymlm");

var $iSvIT = parcelRequire("iSvIT");

var $fDVJn = parcelRequire("fDVJn");
var $kv9H0 = parcelRequire("kv9H0");
var $2e207fed0319cde5$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $2e207fed0319cde5$var$_excluded2 = [
    "className"
];
function $2e207fed0319cde5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2e207fed0319cde5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2e207fed0319cde5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $azswa.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2e207fed0319cde5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2e207fed0319cde5$var$focusRingStyles = null;
var $2e207fed0319cde5$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $2e207fed0319cde5$var$Focusable = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "button" : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, $8ymlm.default)(_ref, $2e207fed0319cde5$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $8ymlm.default)(htmlAttributes, $2e207fed0319cde5$var$_excluded2);
    return /*#__PURE__*/ $iSvIT.createElement(Component, (0, $ccHRj.default)({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $fDVJn.default)([
            "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y",
            isInset && "_1ah3115h _2mwq115h",
            xcss
        ]),
        "data-testid": testId,
        style: $2e207fed0319cde5$var$_objectSpread($2e207fed0319cde5$var$_objectSpread({}, style), {}, {
            "--_1203r2w": (0, $kv9H0.default)("calc(0px - ".concat("var(--ds-border-width-outline, 2px)", ")"))
        })
    }), children);
});
var $2e207fed0319cde5$export$2e2bcd8739ae039 = $2e207fed0319cde5$var$Focusable;

});


parcelRegister("b4z5H", function(module, exports) {

$parcel$export(module.exports, "SplitButtonContext", function () { return $80fb49c103f793b2$export$4b86304b2c0d7e71; });
$parcel$export(module.exports, "useSplitButtonContext", function () { return $80fb49c103f793b2$export$47e2c6fdb142d947; });

var $iSvIT = parcelRequire("iSvIT");
var $80fb49c103f793b2$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $iSvIT.createContext)(undefined);
var $80fb49c103f793b2$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $iSvIT.useContext)($80fb49c103f793b2$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === "navigation") {
        var newContext = {
            spacing: "default",
            appearance: "subtle",
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("5utuA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ff6a1ae55a46715$export$2e2bcd8739ae039; });
function $3ff6a1ae55a46715$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $3ff6a1ae55a46715$var$tabKeyCode = 9;
function $3ff6a1ae55a46715$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $3ff6a1ae55a46715$var$tabKeyCode) return;
    $3ff6a1ae55a46715$var$abort(event);
}
function $3ff6a1ae55a46715$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $3ff6a1ae55a46715$var$abort,
        onMouseUpCapture: $3ff6a1ae55a46715$var$abort,
        onKeyDownCapture: $3ff6a1ae55a46715$var$onKey,
        onKeyUpCapture: $3ff6a1ae55a46715$var$onKey,
        onTouchStartCapture: $3ff6a1ae55a46715$var$abort,
        onTouchEndCapture: $3ff6a1ae55a46715$var$abort,
        onPointerDownCapture: $3ff6a1ae55a46715$var$abort,
        onPointerUpCapture: $3ff6a1ae55a46715$var$abort,
        onClickCapture: $3ff6a1ae55a46715$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $3ff6a1ae55a46715$var$abort
    } : events;
}

});

parcelRegister("i4o09", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d27b37e4db925928$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $cd6Kd = parcelRequire("cd6Kd");
function $d27b37e4db925928$var$getIconSpacing(spacing) {
    switch(spacing){
        case "compact":
            return "small";
        default:
            return "medium";
    }
}
function $d27b37e4db925928$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return "inherit";
    if (appearance === "primary" || appearance === "danger" || appearance === "discovery") return "invert";
    return "inherit";
}
function $d27b37e4db925928$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $cd6Kd.default), {
        size: $d27b37e4db925928$var$getIconSpacing(spacing),
        appearance: $d27b37e4db925928$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});
parcelRegister("cd6Kd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e3bee3e6503db54$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $fDVJn = parcelRequire("fDVJn");

var $iSvIT = parcelRequire("iSvIT");

var $7nG8r = parcelRequire("7nG8r");

var $gye8i = parcelRequire("gye8i");

var $182iY = parcelRequire("182iY");
/**
 * Returns the appropriate circle stroke color.
 */ function $8e3bee3e6503db54$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $gye8i.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $gye8i.N0), ")");
}
var $8e3bee3e6503db54$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $8e3bee3e6503db54$var$loadIn = null;
var $8e3bee3e6503db54$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $8e3bee3e6503db54$var$useLayoutEffect = typeof window === "undefined" ? (0, $iSvIT.useEffect) : (0, $iSvIT.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $8e3bee3e6503db54$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $182iY.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $8e3bee3e6503db54$var$getStrokeColor(appearance);
    var context = (0, $iSvIT.useContext)((0, $7nG8r.default));
    $8e3bee3e6503db54$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : "spinner-wrapper",
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $fDVJn.default)([
            $8e3bee3e6503db54$var$styles.wrapperStyles,
            $8e3bee3e6503db54$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none",
        className: (0, $fDVJn.default)([
            $8e3bee3e6503db54$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $fDVJn.default)([
            $8e3bee3e6503db54$var$styles.circleStyles
        ])
    })));
}));
var $8e3bee3e6503db54$export$2e2bcd8739ae039 = $8e3bee3e6503db54$var$Spinner;

});
parcelRegister("gye8i", function(module, exports) {

$parcel$export(module.exports, "N0", function () { return $c0cac8cf9092ff33$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $c0cac8cf9092ff33$export$c39c0fe0f26207ae; });
// Reds
var $c0cac8cf9092ff33$export$4b84fd0e2c617bd = "#FFEBE6";
var $c0cac8cf9092ff33$export$b34b069eff244586 = "#FFBDAD";
var $c0cac8cf9092ff33$export$be802dd0d8b57f35 = "#FF8F73";
var $c0cac8cf9092ff33$export$60847d42f9da92a6 = "#FF7452";
var $c0cac8cf9092ff33$export$4a7404f376229999 = "#FF5630";
var $c0cac8cf9092ff33$export$2010d0fb4295b346 = "#DE350B";
var $c0cac8cf9092ff33$export$2837b5a1a71d5c02 = "#BF2600";
var $c0cac8cf9092ff33$export$8d9596b529bbb9cf = "#FFFAE6";
var $c0cac8cf9092ff33$export$41060a744ab0b7ae = "#FFF0B3";
var $c0cac8cf9092ff33$export$1cc05bbbf340e559 = "#FFE380";
var $c0cac8cf9092ff33$export$5aae31392d72caaa = "#FFC400";
var $c0cac8cf9092ff33$export$c6930421db9fa514 = "#FFAB00";
var $c0cac8cf9092ff33$export$59619663aa6500fb = "#FF991F";
var $c0cac8cf9092ff33$export$874739ea9e379ab6 = "#FF8B00";
var $c0cac8cf9092ff33$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $c0cac8cf9092ff33$export$69a3bf21b9686c2b = "#ABF5D1";
var $c0cac8cf9092ff33$export$afbce1382ec95f73 = "#79F2C0";
var $c0cac8cf9092ff33$export$747d86715d4175de = "#57D9A3";
var $c0cac8cf9092ff33$export$940e1f69e873f202 = "#36B37E";
var $c0cac8cf9092ff33$export$a49394138f7b8e85 = "#00875A";
var $c0cac8cf9092ff33$export$6fa04827ac68a4fb = "#006644";
var $c0cac8cf9092ff33$export$226de0355ed012f8 = "#DEEBFF";
var $c0cac8cf9092ff33$export$8c13c2ee36917869 = "#B3D4FF";
var $c0cac8cf9092ff33$export$ecfc1dff386a3e7a = "#4C9AFF";
var $c0cac8cf9092ff33$export$215b7063051591f1 = "#2684FF";
var $c0cac8cf9092ff33$export$e62e8919cca44969 = "#0065FF";
var $c0cac8cf9092ff33$export$b3de0ae08da2ce64 = "#0052CC";
var $c0cac8cf9092ff33$export$a6ee3d71bc067634 = "#0747A6";
var $c0cac8cf9092ff33$export$67f15409e87642a1 = "#669DF1";
var $c0cac8cf9092ff33$export$f0539dbc42dbb067 = "#8FB8F6";
var $c0cac8cf9092ff33$export$363e4475840015bb = "#EAE6FF";
var $c0cac8cf9092ff33$export$4b0a4417ed59760f = "#C0B6F2";
var $c0cac8cf9092ff33$export$6011520a64d9a187 = "#998DD9";
var $c0cac8cf9092ff33$export$a7175d4e9206bc80 = "#8777D9";
var $c0cac8cf9092ff33$export$b48405b95304b5a1 = "#6554C0";
var $c0cac8cf9092ff33$export$c71e4279dd54a18d = "#5243AA";
var $c0cac8cf9092ff33$export$147899de772240ec = "#403294";
var $c0cac8cf9092ff33$export$2cf711fe14c66f06 = "#E6FCFF";
var $c0cac8cf9092ff33$export$7a8f4d33f6f9772c = "#B3F5FF";
var $c0cac8cf9092ff33$export$776c9c497ef08533 = "#79E2F2";
var $c0cac8cf9092ff33$export$69cb3ca10c1e330e = "#00C7E6";
var $c0cac8cf9092ff33$export$9dc1ef0f3f48059b = "#00B8D9";
var $c0cac8cf9092ff33$export$7c835c78b6fcdef8 = "#00A3BF";
var $c0cac8cf9092ff33$export$6036577f95c3877e = "#008DA6";
var $c0cac8cf9092ff33$export$29a4f05edc054374 = "#FFFFFF";
var $c0cac8cf9092ff33$export$e655ef011c4aa1a2 = "#FAFBFC";
var $c0cac8cf9092ff33$export$9fdfb749e33cdf97 = "#F4F5F7";
var $c0cac8cf9092ff33$export$3e51e8f1440314ba = "#EBECF0";
var $c0cac8cf9092ff33$export$1ce2d1575d444ceb = "#DFE1E6";
var $c0cac8cf9092ff33$export$8754fc7e6d8b3000 = "#C1C7D0";
var $c0cac8cf9092ff33$export$c2e91cbeada39b8b = "#B3BAC5";
var $c0cac8cf9092ff33$export$5f71e19f3a7ad9de = "#A5ADBA";
var $c0cac8cf9092ff33$export$eaa8c8a70ac22806 = "#97A0AF";
var $c0cac8cf9092ff33$export$7c87d337fb91a97d = "#8993A4";
var $c0cac8cf9092ff33$export$d6447c357493214f = "#7A869A";
var $c0cac8cf9092ff33$export$f563ee71e9ee74cd = "#6B778C";
var $c0cac8cf9092ff33$export$e2ef2124cf4024b1 = "#5E6C84";
var $c0cac8cf9092ff33$export$eece5f492e429f08 = "#505F79";
var $c0cac8cf9092ff33$export$c39c0fe0f26207ae = "#42526E";
var $c0cac8cf9092ff33$export$7090862dc3038a9f = "#344563";
var $c0cac8cf9092ff33$export$ad0bacf983b7ddaa = "#253858";
var $c0cac8cf9092ff33$export$7d61b15e0da132af = "#172B4D";
var $c0cac8cf9092ff33$export$fbda843f0a27fe96 = "#091E42";
var $c0cac8cf9092ff33$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $c0cac8cf9092ff33$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $c0cac8cf9092ff33$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $c0cac8cf9092ff33$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $c0cac8cf9092ff33$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $c0cac8cf9092ff33$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $c0cac8cf9092ff33$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $c0cac8cf9092ff33$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $c0cac8cf9092ff33$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $c0cac8cf9092ff33$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $c0cac8cf9092ff33$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $c0cac8cf9092ff33$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $c0cac8cf9092ff33$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $c0cac8cf9092ff33$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $c0cac8cf9092ff33$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $c0cac8cf9092ff33$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $c0cac8cf9092ff33$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $c0cac8cf9092ff33$export$2f6319cf7d736c2a = "#E6EDFA";
var $c0cac8cf9092ff33$export$95126bc8884d6634 = "#DCE5F5";
var $c0cac8cf9092ff33$export$8338d8c35d44ff1 = "#CED9EB";
var $c0cac8cf9092ff33$export$5368d76ae4fbbda7 = "#B8C7E0";
var $c0cac8cf9092ff33$export$9f0a771d16ec8d36 = "#ABBBD6";
var $c0cac8cf9092ff33$export$abcf8c38338b4aa5 = "#9FB0CC";
var $c0cac8cf9092ff33$export$97e81faa16a182c7 = "#8C9CB8";
var $c0cac8cf9092ff33$export$bfe21c59123ecf33 = "#7988A3";
var $c0cac8cf9092ff33$export$ee82aa2ea6a1558 = "#67758F";
var $c0cac8cf9092ff33$export$682927c6ed76be02 = "#56637A";
var $c0cac8cf9092ff33$export$91fd9994c5be9757 = "#455166";
var $c0cac8cf9092ff33$export$d281fbfe3cff2df6 = "#3B475C";
var $c0cac8cf9092ff33$export$3902c91d8b98a753 = "#313D52";
var $c0cac8cf9092ff33$export$8e8133c1ba5845b5 = "#283447";
var $c0cac8cf9092ff33$export$33ff357f6620b39 = "#202B3D";
var $c0cac8cf9092ff33$export$633847cf062b69e0 = "#1B2638";
var $c0cac8cf9092ff33$export$9776a6e503bdbf76 = "#121A29";
var $c0cac8cf9092ff33$export$6c813d5160dff5db = "#0E1624";
var $c0cac8cf9092ff33$export$3d4f271a500072a = "#0D1424";
var $c0cac8cf9092ff33$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $c0cac8cf9092ff33$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $c0cac8cf9092ff33$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $c0cac8cf9092ff33$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $c0cac8cf9092ff33$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $c0cac8cf9092ff33$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $c0cac8cf9092ff33$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $c0cac8cf9092ff33$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $c0cac8cf9092ff33$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $c0cac8cf9092ff33$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $c0cac8cf9092ff33$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $c0cac8cf9092ff33$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $c0cac8cf9092ff33$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $c0cac8cf9092ff33$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $c0cac8cf9092ff33$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $c0cac8cf9092ff33$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $c0cac8cf9092ff33$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $c0cac8cf9092ff33$export$d2adc5dedf09fced = "#292A2E";
var $c0cac8cf9092ff33$export$f51762073d2bb381 = "#94C748";
var $c0cac8cf9092ff33$export$95e26d54def96891 = "#B3DF72";

});

parcelRegister("182iY", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $0d28538868a4d577$export$4e9f1640bbe7a1a8; });
var $0d28538868a4d577$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});




parcelRegister("lI79y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fce341846adb7256$export$2e2bcd8739ae039; });
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $fDVJn = parcelRequire("fDVJn");

var $iSvIT = parcelRequire("iSvIT");
var $fce341846adb7256$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    beforeIcon: "_1he91b66 _w795v77o",
    afterIcon: "_1he9v77o _w7951b66",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $fce341846adb7256$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? "text" : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        className: (0, $fDVJn.default)([
            $fce341846adb7256$var$styles.common,
            type === "text" && $fce341846adb7256$var$styles.text,
            type === "icon" && $fce341846adb7256$var$styles.icon,
            isLoading && $fce341846adb7256$var$styles.fade,
            position === "before" && $fce341846adb7256$var$styles.beforeIcon,
            position === "after" && $fce341846adb7256$var$styles.afterIcon
        ])
    }, children);
};
var $fce341846adb7256$export$2e2bcd8739ae039 = $fce341846adb7256$var$Content;

});

parcelRegister("jFVvO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e52e755ab4da097f$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
function $e52e755ab4da097f$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === "function" // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $e52e755ab4da097f$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    return(/*#__PURE__*/ // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, $e52e755ab4da097f$var$isIconRenderProp(Icon) ? Icon({
        label: "",
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Icon, {
        label: "",
        color: "currentColor"
    })));
};
var $e52e755ab4da097f$export$2e2bcd8739ae039 = $e52e755ab4da097f$var$IconRenderer;

});


parcelRegister("lLYBc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd9cfe6f8c583a5d$export$2e2bcd8739ae039; });
/* heading.partial.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $jAOBB = parcelRequire("jAOBB");

var $iSvIT = parcelRequire("iSvIT");

var $fDVJn = parcelRequire("fDVJn");

var $g2SaA = parcelRequire("g2SaA");

var $4qov4 = parcelRequire("4qov4");

var $5sFoz = parcelRequire("5sFoz");

var $XAEGR = parcelRequire("XAEGR");
var $fd9cfe6f8c583a5d$var$sizeTagMap = {
    xxlarge: "h1",
    xlarge: "h1",
    large: "h2",
    medium: "h3",
    small: "h4",
    xsmall: "h5",
    xxsmall: "h6"
};
var $fd9cfe6f8c583a5d$var$styles = {
    reset: "_1mouidpf _1dyz4jg8 _1p1dglyw"
};
var $fd9cfe6f8c583a5d$var$headingColorStylesMap = {
    "color.text": "_syaz1fxt",
    "color.text.inverse": "_syaz15cr",
    "color.text.warning.inverse": "_syazal3n"
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c47bed69b7a147a63fdb8c394e98514a>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $fd9cfe6f8c583a5d$var$headingSizeStylesMap = {
    xxlarge: "_11c84xcc",
    xlarge: "_11c81c04",
    large: "_11c8nf1z",
    medium: "_11c8lodh",
    small: "_11c8nbxd",
    xsmall: "_11c8140y",
    xxsmall: "_11c81vhk"
};
/**
 * @codegenEnd
 */ var $fd9cfe6f8c583a5d$var$useColor = function useColor(colorProp) {
    var surface = (0, $4qov4.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $g2SaA.inverseColorMap).hasOwnProperty(surface)) return (0, $g2SaA.inverseColorMap)[surface];
    return "color.text";
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $fd9cfe6f8c583a5d$var$Heading = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var children = props.children, size = props.size, id = props.id, testId = props.testId, as = props.as, colorProp = props.color;
    typeof $XAEGR;
    var _useHeading = (0, $5sFoz.useHeading)($fd9cfe6f8c583a5d$var$sizeTagMap[size]), _useHeading2 = (0, $jAOBB.default)(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === "div" && hLevel;
    var color = $fd9cfe6f8c583a5d$var$useColor(colorProp);
    return /*#__PURE__*/ $iSvIT.createElement(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $fDVJn.default)([
            $fd9cfe6f8c583a5d$var$styles.reset,
            size && $fd9cfe6f8c583a5d$var$headingSizeStylesMap[size],
            $fd9cfe6f8c583a5d$var$headingColorStylesMap[color]
        ])
    }, children);
});
var $fd9cfe6f8c583a5d$export$2e2bcd8739ae039 = $fd9cfe6f8c583a5d$var$Heading;

});
parcelRegister("g2SaA", function(module, exports) {

$parcel$export(module.exports, "inverseColorMap", function () { return $bae6da3b534ab1b9$export$2185ce37f9bdd963; });

var $azswa = parcelRequire("azswa");

var $2ZUkg = parcelRequire("2ZUkg");

var $6oUwD = parcelRequire("6oUwD");
function $bae6da3b534ab1b9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bae6da3b534ab1b9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bae6da3b534ab1b9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $azswa.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bae6da3b534ab1b9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bae6da3b534ab1b9$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $bae6da3b534ab1b9$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $bae6da3b534ab1b9$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $bae6da3b534ab1b9$export$632685d741f3dbbf = $bae6da3b534ab1b9$var$_objectSpread($bae6da3b534ab1b9$var$_objectSpread({}, $bae6da3b534ab1b9$export$958d0ae7f2977ae4), $bae6da3b534ab1b9$export$d2dc61f58390201c);
var $bae6da3b534ab1b9$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $bae6da3b534ab1b9$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $bae6da3b534ab1b9$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $bae6da3b534ab1b9$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $bae6da3b534ab1b9$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $bae6da3b534ab1b9$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $bae6da3b534ab1b9$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $bae6da3b534ab1b9$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtlest": "var(--ds-icon-subtlest, #6B778C)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $bae6da3b534ab1b9$export$b5f31a7e431d2eab = {
    "1": 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $bae6da3b534ab1b9$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $bae6da3b534ab1b9$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $bae6da3b534ab1b9$export$6ffa317d5e70375 = {
    "font.body": 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.UNSAFE_small": 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.code": 'var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.heading.large": 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.medium": 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.small": 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xlarge": 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xsmall": 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xxlarge": 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xxsmall": 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $bae6da3b534ab1b9$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $bae6da3b534ab1b9$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $bae6da3b534ab1b9$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $bae6da3b534ab1b9$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $bae6da3b534ab1b9$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $bae6da3b534ab1b9$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $2ZUkg.css)((0, $azswa.default)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $bae6da3b534ab1b9$export$e615f061ca585a6c = $bae6da3b534ab1b9$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $bae6da3b534ab1b9$export$ca0f9c2de39ffed7(spacingProperty, $bae6da3b534ab1b9$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $bae6da3b534ab1b9$export$bf46c3f9eeafc71f = $bae6da3b534ab1b9$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $bae6da3b534ab1b9$export$ca0f9c2de39ffed7(spacingProperty, $bae6da3b534ab1b9$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $bae6da3b534ab1b9$export$e7af83bafe7f9e63 = $bae6da3b534ab1b9$export$ca0f9c2de39ffed7("backgroundColor", $bae6da3b534ab1b9$export$d1d79bf68ac056bd);
var $bae6da3b534ab1b9$export$3a1bcba60b23d7f0 = $bae6da3b534ab1b9$export$ca0f9c2de39ffed7("color", $bae6da3b534ab1b9$export$8473307aa00d6ea1);
var $bae6da3b534ab1b9$export$45f3f4fe16f9f7d5 = $bae6da3b534ab1b9$export$ca0f9c2de39ffed7("fontWeight", $bae6da3b534ab1b9$export$303e322c6b1ed114);
var $bae6da3b534ab1b9$export$68cc305da27dbaa4 = $bae6da3b534ab1b9$export$ca0f9c2de39ffed7("fontFamily", $bae6da3b534ab1b9$export$3c7e9587132614b4);
var $bae6da3b534ab1b9$export$128f10c238242f83 = $bae6da3b534ab1b9$export$ca0f9c2de39ffed7("font", $bae6da3b534ab1b9$export$6ffa317d5e70375);
var $bae6da3b534ab1b9$export$219d364c0da35ae4 = $bae6da3b534ab1b9$export$ca0f9c2de39ffed7("font", $bae6da3b534ab1b9$export$236bfe3a33ef1292);
var $bae6da3b534ab1b9$export$38845ca010b93505 = $bae6da3b534ab1b9$export$ca0f9c2de39ffed7("fontWeight", $bae6da3b534ab1b9$export$855cfd311192d666);
var $bae6da3b534ab1b9$export$ff257d957d48c421 = $bae6da3b534ab1b9$export$ca0f9c2de39ffed7((0, $6oUwD.CURRENT_SURFACE_CSS_VAR), $bae6da3b534ab1b9$export$41a358c9c2356760);
var $bae6da3b534ab1b9$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $bae6da3b534ab1b9$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("6oUwD", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $4a90d4bc344f029e$export$9d7b58831ae93caa; });
var $4a90d4bc344f029e$export$4ef52930e33717cd = "data-theme";
var $4a90d4bc344f029e$export$a00eac3f8684bcd0 = "data-color-mode";
var $4a90d4bc344f029e$export$2112803007239c61 = "data-contrast-mode";
var $4a90d4bc344f029e$export$352e418ed5b6193a = "data-custom-theme";
var $4a90d4bc344f029e$export$6f0c6fb8c80fcc92 = "ds";
var $4a90d4bc344f029e$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $4a90d4bc344f029e$export$dddac1532e822863 = "--".concat($4a90d4bc344f029e$export$6f0c6fb8c80fcc92, "-token-not-found");
var $4a90d4bc344f029e$export$9d7b58831ae93caa = "--".concat($4a90d4bc344f029e$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("4qov4", function(module, exports) {

$parcel$export(module.exports, "useSurface", function () { return $338c985d7fa9ee19$export$1aeb4f6b93c4540d; });

var $iSvIT = parcelRequire("iSvIT");
var $338c985d7fa9ee19$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $iSvIT.createContext)("elevation.surface");
var $338c985d7fa9ee19$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $iSvIT.useContext)($338c985d7fa9ee19$export$1ca2a26fecb070ae);
};
$338c985d7fa9ee19$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});

parcelRegister("5sFoz", function(module, exports) {

$parcel$export(module.exports, "useHeading", function () { return $3f9fad7ec4911554$export$97a37b1befbbf9b1; });

var $iSvIT = parcelRequire("iSvIT");
// Allows support for heading levels 1-9 via aria-level
var $3f9fad7ec4911554$var$HeadingLevelContext = /*#__PURE__*/ (0, $iSvIT.createContext)(0);
/**
 * @internal
 * @returns The current heading level context.
 */ var $3f9fad7ec4911554$var$useHeadingLevel = function useHeadingLevel() {
    return (0, $iSvIT.useContext)($3f9fad7ec4911554$var$HeadingLevelContext);
};
var $3f9fad7ec4911554$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $3f9fad7ec4911554$var$useHeadingLevel();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? "div" : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $3f9fad7ec4911554$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $3f9fad7ec4911554$var$useHeadingLevel();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($3f9fad7ec4911554$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $3f9fad7ec4911554$export$2e2bcd8739ae039 = $3f9fad7ec4911554$var$HeadingLevelContextProvider;

});


parcelRegister("8CsyJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2c17176afeb2169f76dc501092efdf0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6468069ecc1eb46c$var$_react = $6468069ecc1eb46c$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $6468069ecc1eb46c$var$_cross = $6468069ecc1eb46c$var$_interopRequireDefault((parcelRequire("8uCDP")));

var $6468069ecc1eb46c$var$_cross2 = $6468069ecc1eb46c$var$_interopRequireDefault((parcelRequire("biUnN")));
function $6468069ecc1eb46c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6468069ecc1eb46c$var$CrossIcon = (props)=>/*#__PURE__*/ $6468069ecc1eb46c$var$_react.default.createElement($6468069ecc1eb46c$var$_cross.default, Object.assign({
        name: "CrossIcon",
        LEGACY_fallbackIcon: $6468069ecc1eb46c$var$_cross2.default
    }, props));
$6468069ecc1eb46c$var$CrossIcon.displayName = "CrossIconMigration";
var $6468069ecc1eb46c$var$_default = module.exports.default = $6468069ecc1eb46c$var$CrossIcon;

});
parcelRegister("8uCDP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62ef196e7479121a$var$_react = $62ef196e7479121a$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $62ef196e7479121a$var$_baseNew = $62ef196e7479121a$var$_interopRequireDefault((parcelRequire("lfiRe")));
function $62ef196e7479121a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $62ef196e7479121a$var$CrossIcon = (props)=>/*#__PURE__*/ $62ef196e7479121a$var$_react.default.createElement($62ef196e7479121a$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$62ef196e7479121a$var$CrossIcon.displayName = "CrossIcon";
var $62ef196e7479121a$var$_default = module.exports.default = $62ef196e7479121a$var$CrossIcon;

});
parcelRegister("lfiRe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("5ZUpO")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("5ZUpO")).Icon; });

var $5ZUpO = parcelRequire("5ZUpO");

});
parcelRegister("5ZUpO", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $45de692ebf37d403$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $45de692ebf37d403$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $i5VJ8 = parcelRequire("i5VJ8");

var $jxLBU = parcelRequire("jxLBU");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $45de692ebf37d403$var$svgStyles = null;
var $45de692ebf37d403$var$iconStyles = null;
var $45de692ebf37d403$var$utilityIconStyles = null;
var $45de692ebf37d403$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $45de692ebf37d403$var$baseHcmStyles = null;
var $45de692ebf37d403$var$scaleSize = null;
var $45de692ebf37d403$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $45de692ebf37d403$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $45de692ebf37d403$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $45de692ebf37d403$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $45de692ebf37d403$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $45de692ebf37d403$export$f04a61298a47a40f = /*#__PURE__*/ (0, $iSvIT.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "none" : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $jxLBU.fg)("platform-visual-refresh-icons")) // parse out unnecessary props
    return /*#__PURE__*/ $iSvIT.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "core";
    var size = "medium";
    if ("size" in props && props.size !== undefined) {
        if (typeof props.size === "string") size = props.size === "small" || props.size === "medium" ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === "small" || newSize === "medium" ? newSize : size;
        }
    }
    var baseSize = $45de692ebf37d403$var$baseSizeMap[type];
    var viewBoxPadding = $45de692ebf37d403$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $i5VJ8.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === "utility" || size === "small") && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $iSvIT.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $i5VJ8.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === "utility" ? $45de692ebf37d403$var$utilSizes[spacing] : size === "small" ? $45de692ebf37d403$var$coreSizeSmall[spacing] : $45de692ebf37d403$var$coreSizeMedium[spacing]
        ])
    }));
});
var $45de692ebf37d403$export$2e2bcd8739ae039 = $45de692ebf37d403$export$f04a61298a47a40f;

});
parcelRegister("i5VJ8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2c578fc46701469$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $d2c578fc46701469$var$ATOMIC_GROUP_LENGTH = 5;
function $d2c578fc46701469$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $d2c578fc46701469$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});




parcelRegister("biUnN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83ad1c9c60c883a5$var$_react = $83ad1c9c60c883a5$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $eRdqf = parcelRequire("eRdqf");
function $83ad1c9c60c883a5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $83ad1c9c60c883a5$var$CrossIcon = (props)=>/*#__PURE__*/ $83ad1c9c60c883a5$var$_react.default.createElement($eRdqf.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props));
$83ad1c9c60c883a5$var$CrossIcon.displayName = "CrossIcon";
var $83ad1c9c60c883a5$var$_default = module.exports.default = $83ad1c9c60c883a5$var$CrossIcon;

});
parcelRegister("eRdqf", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $ad106d59015a6f86$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $ccHRj = parcelRequire("ccHRj");

var $azswa = parcelRequire("azswa");

var $iSvIT = parcelRequire("iSvIT");

var $i5VJ8 = parcelRequire("i5VJ8");
function $ad106d59015a6f86$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ad106d59015a6f86$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ad106d59015a6f86$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $azswa.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ad106d59015a6f86$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $ad106d59015a6f86$var$iconStyles = null;
var $ad106d59015a6f86$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $ad106d59015a6f86$var$baseHcmStyles = null;
var $ad106d59015a6f86$var$primaryEqualsSecondaryHcmStyles = null;
var $ad106d59015a6f86$var$secondaryTransparentHcmStyles = null;
var $ad106d59015a6f86$export$f04a61298a47a40f = /*#__PURE__*/ (0, $iSvIT.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $iSvIT.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + "px",
        height: height + "px"
    } : null;
    return /*#__PURE__*/ $iSvIT.createElement("span", (0, $ccHRj.default)({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $ad106d59015a6f86$var$_objectSpread($ad106d59015a6f86$var$_objectSpread({}, customDimensions), {}, {
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $i5VJ8.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === "transparent" && "_4fyi1j28",
            size && $ad106d59015a6f86$var$sizeStyles[size]
        ])
    }));
});
var $ad106d59015a6f86$export$2e2bcd8739ae039 = $ad106d59015a6f86$export$f04a61298a47a40f;

});



parcelRegister("gLQGX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c359e8a552e49859$export$2e2bcd8739ae039; });
/* inline.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $ccHRj = parcelRequire("ccHRj");

var $8ymlm = parcelRequire("8ymlm");

var $iSvIT = parcelRequire("iSvIT");

var $fDVJn = parcelRequire("fDVJn");

var $8Mk0U = parcelRequire("8Mk0U");

var $8R102 = parcelRequire("8R102");
var $c359e8a552e49859$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $c359e8a552e49859$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $c359e8a552e49859$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        className: (0, $fDVJn.default)([
            $c359e8a552e49859$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $c359e8a552e49859$var$Inline = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, $8ymlm.default)(_ref2, $c359e8a552e49859$var$_excluded);
    var separatorComponent = typeof separator === "string" ? /*#__PURE__*/ $iSvIT.createElement($c359e8a552e49859$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $iSvIT.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $iSvIT.createElement((0, $iSvIT.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $iSvIT.createElement((0, $8R102.default), (0, $ccHRj.default)({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: (0, $8Mk0U.cx)(grow === "hug" && $c359e8a552e49859$var$styles.hug, grow === "fill" && $c359e8a552e49859$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$c359e8a552e49859$var$Inline.displayName = "Inline";
var $c359e8a552e49859$export$2e2bcd8739ae039 = $c359e8a552e49859$var$Inline;

});
parcelRegister("8Mk0U", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $664254b793f3ca1b$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("iSvIT");


var $7yn5t = parcelRequire("7yn5t");
var $664254b793f3ca1b$var$_createStrictAPI = (0, $7yn5t.createStrictAPI)(), $664254b793f3ca1b$var$XCSSProp = $664254b793f3ca1b$var$_createStrictAPI.XCSSProp, $664254b793f3ca1b$export$dbf350e5966cf602 = $664254b793f3ca1b$var$_createStrictAPI.css, $664254b793f3ca1b$export$eb1ecd84a24ee424 = $664254b793f3ca1b$var$_createStrictAPI.cssMap, $664254b793f3ca1b$export$a274e22fb40f762e = $664254b793f3ca1b$var$_createStrictAPI.cx;
 // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 
});

parcelRegister("8R102", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67240c743ae1fdd8$export$2e2bcd8739ae039; });
/* flex.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $ccHRj = parcelRequire("ccHRj");

var $8ymlm = parcelRequire("8ymlm");

var $iSvIT = parcelRequire("iSvIT");

var $fDVJn = parcelRequire("fDVJn");
var $67240c743ae1fdd8$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $67240c743ae1fdd8$var$rowGapMap = {
    "space.0": "_1p57ze3t",
    "space.025": "_1p57v77o",
    "space.050": "_1p571b66",
    "space.075": "_1p5712x7",
    "space.100": "_1p57u2gc",
    "space.150": "_1p57utpp",
    "space.200": "_1p57pxbi",
    "space.250": "_1p57v47k",
    "space.300": "_1p571ejb",
    "space.400": "_1p57xy5q",
    "space.500": "_1p571jfw",
    "space.600": "_1p57oahv",
    "space.800": "_1p57xncg",
    "space.1000": "_1p571epz"
};
var $67240c743ae1fdd8$var$columnGapMap = {
    "space.0": "_gy1pze3t",
    "space.025": "_gy1pv77o",
    "space.050": "_gy1p1b66",
    "space.075": "_gy1p12x7",
    "space.100": "_gy1pu2gc",
    "space.150": "_gy1putpp",
    "space.200": "_gy1ppxbi",
    "space.250": "_gy1pv47k",
    "space.300": "_gy1p1ejb",
    "space.400": "_gy1pxy5q",
    "space.500": "_gy1p1jfw",
    "space.600": "_gy1poahv",
    "space.800": "_gy1pxncg",
    "space.1000": "_gy1p1epz"
};
var $67240c743ae1fdd8$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    "space-between": "_1bah1yb4",
    "space-around": "_1bah1b1v",
    "space-evenly": "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $67240c743ae1fdd8$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $67240c743ae1fdd8$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $67240c743ae1fdd8$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $67240c743ae1fdd8$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $67240c743ae1fdd8$var$Flex = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, $8ymlm.default)(_ref, $67240c743ae1fdd8$var$_excluded);
    return /*#__PURE__*/ $iSvIT.createElement(Component, (0, $ccHRj.default)({}, ariaAttributes, {
        role: role,
        className: (0, $fDVJn.default)([
            $67240c743ae1fdd8$var$styles.root,
            gap && $67240c743ae1fdd8$var$columnGapMap[gap],
            columnGap && $67240c743ae1fdd8$var$columnGapMap[columnGap],
            gap && $67240c743ae1fdd8$var$rowGapMap[gap],
            rowGap && $67240c743ae1fdd8$var$rowGapMap[rowGap],
            alignItems && $67240c743ae1fdd8$var$alignItemsMap[alignItems],
            direction && $67240c743ae1fdd8$var$flexDirectionMap[direction],
            justifyContent && $67240c743ae1fdd8$var$justifyContentMap[justifyContent],
            wrap && $67240c743ae1fdd8$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$67240c743ae1fdd8$var$Flex.displayName = "Flex";
var $67240c743ae1fdd8$export$2e2bcd8739ae039 = $67240c743ae1fdd8$var$Flex;

});


parcelRegister("glx8J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be685069b976f56c$export$2e2bcd8739ae039; });
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $ccHRj = parcelRequire("ccHRj");

var $8ymlm = parcelRequire("8ymlm");

var $iSvIT = parcelRequire("iSvIT");


var $8Mk0U = parcelRequire("8Mk0U");

var $8R102 = parcelRequire("8R102");
var $be685069b976f56c$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "spread",
    "grow",
    "space",
    "children",
    "testId",
    "xcss",
    "role"
];
var $be685069b976f56c$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $be685069b976f56c$var$Stack = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? "stretch" : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role, ariaAttributes = (0, $8ymlm.default)(_ref, $be685069b976f56c$var$_excluded);
    return /*#__PURE__*/ $iSvIT.createElement((0, $8R102.default), (0, $ccHRj.default)({}, ariaAttributes, {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $8Mk0U.cx)(grow === "hug" && $be685069b976f56c$var$styles.hug, grow === "fill" && $be685069b976f56c$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$be685069b976f56c$var$Stack.displayName = "Stack";
var $be685069b976f56c$export$2e2bcd8739ae039 = $be685069b976f56c$var$Stack;

});

parcelRegister("lB0RK", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", function () { return $fb8db99d7b6034d1$export$e9b82d2e21ac0c1f; });

var $azswa = parcelRequire("azswa");

var $iSvIT = parcelRequire("iSvIT");

var $dICtm = parcelRequire("dICtm");

var $6DU6k = parcelRequire("6DU6k");

var $ddBpF = parcelRequire("ddBpF");

var $jEIQR = parcelRequire("jEIQR");

var $fn8KK = parcelRequire("fn8KK");

var $5b5Vl = parcelRequire("5b5Vl");

var $jxLBU = parcelRequire("jxLBU");

var $imJwX = parcelRequire("imJwX");
function $fb8db99d7b6034d1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fb8db99d7b6034d1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fb8db99d7b6034d1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $azswa.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fb8db99d7b6034d1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fb8db99d7b6034d1$var$appearanceIconSchema = {
    information: {
        backgroundColor: "var(--ds-background-information, ".concat((0, $imJwX.B50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($jEIQR))),
        primaryIconColor: "var(--ds-icon-information, ".concat((0, $imJwX.B500), ")")
    },
    warning: {
        backgroundColor: "var(--ds-background-warning, ".concat((0, $imJwX.Y50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($5b5Vl))),
        primaryIconColor: "var(--ds-icon-warning, ".concat((0, $imJwX.Y500), ")")
    },
    error: {
        backgroundColor: "var(--ds-background-danger, ".concat((0, $imJwX.R50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ddBpF))),
        primaryIconColor: "var(--ds-icon-danger, ".concat((0, $imJwX.R500), ")")
    },
    success: {
        backgroundColor: "var(--ds-background-success, ".concat((0, $imJwX.G50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($fn8KK))),
        primaryIconColor: "var(--ds-icon-success, ".concat((0, $imJwX.G500), ")")
    },
    discovery: {
        backgroundColor: "var(--ds-background-discovery, ".concat((0, $imJwX.P50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($6DU6k))),
        primaryIconColor: "var(--ds-icon-discovery, ".concat((0, $imJwX.P500), ")")
    },
    discoveryUpdated: {
        backgroundColor: "var(--ds-background-discovery, ".concat((0, $imJwX.P50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dICtm))),
        primaryIconColor: "var(--ds-icon-discovery, ".concat((0, $imJwX.P500), ")")
    }
};
function $fb8db99d7b6034d1$export$e9b82d2e21ac0c1f(appearance, icon) {
    var appearanceIconStyles = $fb8db99d7b6034d1$var$appearanceIconSchema[appearance === "discovery" && (0, $jxLBU.fg)("platform_dst_section_message_discovery_icon") ? "discoveryUpdated" : appearance] || $fb8db99d7b6034d1$var$appearanceIconSchema.information;
    var AppearanceIcon = function AppearanceIcon(_ref) {
        var size = _ref.size, primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    };
    var Icon = icon || AppearanceIcon;
    return $fb8db99d7b6034d1$var$_objectSpread($fb8db99d7b6034d1$var$_objectSpread({}, appearanceIconStyles), {}, {
        Icon: Icon
    });
}

});
parcelRegister("dICtm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5501f2ec2c7fc2907a8ddc6771935d76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9fcd3a44d85f9ebe$var$_react = $9fcd3a44d85f9ebe$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $9fcd3a44d85f9ebe$var$_discovery = $9fcd3a44d85f9ebe$var$_interopRequireDefault((parcelRequire("dYwn5")));

var $9fcd3a44d85f9ebe$var$_note = $9fcd3a44d85f9ebe$var$_interopRequireDefault((parcelRequire("cZilY")));
function $9fcd3a44d85f9ebe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DiscoveryIcon.
 * This component is DiscoveryIcon, with `UNSAFE_fallbackIcon` set to "EditorNoteIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9fcd3a44d85f9ebe$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $9fcd3a44d85f9ebe$var$_react.default.createElement($9fcd3a44d85f9ebe$var$_discovery.default, Object.assign({
        name: "DiscoveryIcon",
        LEGACY_fallbackIcon: $9fcd3a44d85f9ebe$var$_note.default
    }, props));
$9fcd3a44d85f9ebe$var$DiscoveryIcon.displayName = "DiscoveryIconMigration";
var $9fcd3a44d85f9ebe$var$_default = module.exports.default = $9fcd3a44d85f9ebe$var$DiscoveryIcon;

});
parcelRegister("dYwn5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84ac540d37aa7b8e7ab349dbbb474c30>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2c9fd410b222a99$var$_react = $a2c9fd410b222a99$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $a2c9fd410b222a99$var$_baseNew = $a2c9fd410b222a99$var$_interopRequireDefault((parcelRequire("lfiRe")));
function $a2c9fd410b222a99$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Discovery".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a2c9fd410b222a99$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $a2c9fd410b222a99$var$_react.default.createElement($a2c9fd410b222a99$var$_baseNew.default, Object.assign({
        name: "DiscoveryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h6v-4.75C9 9.56 9.56 9 10.25 9H15V3a2 2 0 0 0-2-2M4 5.5h7V4H4zM4 9h3V7.5H4z" clip-rule="evenodd"/><path fill="currentcolor" d="M11.25 10.5a.75.75 0 0 0-.75.75v3.81l4.56-4.56z"/>`
    }, props));
$a2c9fd410b222a99$var$DiscoveryIcon.displayName = "DiscoveryIcon";
var $a2c9fd410b222a99$var$_default = module.exports.default = $a2c9fd410b222a99$var$DiscoveryIcon;

});

parcelRegister("cZilY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $97496b243c46e9d9$var$_react = $97496b243c46e9d9$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $eRdqf = parcelRequire("eRdqf");
function $97496b243c46e9d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $97496b243c46e9d9$var$EditorNoteIcon = (props)=>/*#__PURE__*/ $97496b243c46e9d9$var$_react.default.createElement($eRdqf.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 4h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m1.5 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm0 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props));
$97496b243c46e9d9$var$EditorNoteIcon.displayName = "EditorNoteIcon";
var $97496b243c46e9d9$var$_default = module.exports.default = $97496b243c46e9d9$var$EditorNoteIcon;

});


parcelRegister("6DU6k", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::62c47233d9edbba3b204e8a396289dde>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4d61e7141c59f054$var$_react = $4d61e7141c59f054$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $4d61e7141c59f054$var$_questionCircle = $4d61e7141c59f054$var$_interopRequireDefault((parcelRequire("a5who")));

var $4d61e7141c59f054$var$_questionCircle2 = $4d61e7141c59f054$var$_interopRequireDefault((parcelRequire("3aWk4")));
function $4d61e7141c59f054$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for QuestionCircleIcon.
 * This component is QuestionCircleIcon, with `UNSAFE_fallbackIcon` set to "QuestionCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4d61e7141c59f054$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $4d61e7141c59f054$var$_react.default.createElement($4d61e7141c59f054$var$_questionCircle.default, Object.assign({
        name: "QuestionCircleIcon",
        LEGACY_fallbackIcon: $4d61e7141c59f054$var$_questionCircle2.default
    }, props));
$4d61e7141c59f054$var$QuestionCircleIcon.displayName = "QuestionCircleIconMigration";
var $4d61e7141c59f054$var$_default = module.exports.default = $4d61e7141c59f054$var$QuestionCircleIcon;

});
parcelRegister("a5who", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8bb31d7b8eb39bae440b5a0002b7aa63>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75836910362a1a4e$var$_react = $75836910362a1a4e$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $75836910362a1a4e$var$_baseNew = $75836910362a1a4e$var$_interopRequireDefault((parcelRequire("lfiRe")));
function $75836910362a1a4e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75836910362a1a4e$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $75836910362a1a4e$var$_react.default.createElement($75836910362a1a4e$var$_baseNew.default, Object.assign({
        name: "QuestionCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$75836910362a1a4e$var$QuestionCircleIcon.displayName = "QuestionCircleIcon";
var $75836910362a1a4e$var$_default = module.exports.default = $75836910362a1a4e$var$QuestionCircleIcon;

});

parcelRegister("3aWk4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $24ff8bf4ce1ae4c8$var$_react = $24ff8bf4ce1ae4c8$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $eRdqf = parcelRequire("eRdqf");
function $24ff8bf4ce1ae4c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $24ff8bf4ce1ae4c8$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $24ff8bf4ce1ae4c8$var$_react.default.createElement($eRdqf.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="18" r="1" fill="inherit"/><path fill="inherit" d="M15.89 9.05a3.98 3.98 0 0 0-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.99.99 0 0 0 .982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 0 1 4.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 0 0-1 .987v2.014a1.001 1.001 0 0 0 2.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0 0 15.89 9.05"/></g></svg>`
    }, props));
$24ff8bf4ce1ae4c8$var$QuestionCircleIcon.displayName = "QuestionCircleIcon";
var $24ff8bf4ce1ae4c8$var$_default = module.exports.default = $24ff8bf4ce1ae4c8$var$QuestionCircleIcon;

});


parcelRegister("ddBpF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f636032ea4a949f6a3ed21b2a88730cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $99f982b037501b41$var$_react = $99f982b037501b41$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $99f982b037501b41$var$_statusError = $99f982b037501b41$var$_interopRequireDefault((parcelRequire("8cIR3")));

var $99f982b037501b41$var$_error = $99f982b037501b41$var$_interopRequireDefault((parcelRequire("7GTFh")));
function $99f982b037501b41$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $99f982b037501b41$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $99f982b037501b41$var$_react.default.createElement($99f982b037501b41$var$_statusError.default, Object.assign({
        name: "StatusErrorIcon",
        LEGACY_fallbackIcon: $99f982b037501b41$var$_error.default
    }, props));
$99f982b037501b41$var$StatusErrorIcon.displayName = "StatusErrorIconMigration";
var $99f982b037501b41$var$_default = module.exports.default = $99f982b037501b41$var$StatusErrorIcon;

});
parcelRegister("8cIR3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f923ce996f3bdaf$var$_react = $5f923ce996f3bdaf$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $5f923ce996f3bdaf$var$_baseNew = $5f923ce996f3bdaf$var$_interopRequireDefault((parcelRequire("lfiRe")));
function $5f923ce996f3bdaf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5f923ce996f3bdaf$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $5f923ce996f3bdaf$var$_react.default.createElement($5f923ce996f3bdaf$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$5f923ce996f3bdaf$var$StatusErrorIcon.displayName = "StatusErrorIcon";
var $5f923ce996f3bdaf$var$_default = module.exports.default = $5f923ce996f3bdaf$var$StatusErrorIcon;

});

parcelRegister("7GTFh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5997a284c6de362e$var$_react = $5997a284c6de362e$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $eRdqf = parcelRequire("eRdqf");
function $5997a284c6de362e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5997a284c6de362e$var$ErrorIcon = (props)=>/*#__PURE__*/ $5997a284c6de362e$var$_react.default.createElement($eRdqf.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$5997a284c6de362e$var$ErrorIcon.displayName = "ErrorIcon";
var $5997a284c6de362e$var$_default = module.exports.default = $5997a284c6de362e$var$ErrorIcon;

});


parcelRegister("jEIQR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::750ecc162e36259ef90344888c589176>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e4f48b563ba25f50$var$_react = $e4f48b563ba25f50$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $e4f48b563ba25f50$var$_statusInformation = $e4f48b563ba25f50$var$_interopRequireDefault((parcelRequire("fyyKn")));

var $e4f48b563ba25f50$var$_info = $e4f48b563ba25f50$var$_interopRequireDefault((parcelRequire("ekJkm")));
function $e4f48b563ba25f50$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusInformationIcon.
 * This component is StatusInformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e4f48b563ba25f50$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $e4f48b563ba25f50$var$_react.default.createElement($e4f48b563ba25f50$var$_statusInformation.default, Object.assign({
        name: "StatusInformationIcon",
        LEGACY_fallbackIcon: $e4f48b563ba25f50$var$_info.default
    }, props));
$e4f48b563ba25f50$var$StatusInformationIcon.displayName = "StatusInformationIconMigration";
var $e4f48b563ba25f50$var$_default = module.exports.default = $e4f48b563ba25f50$var$StatusInformationIcon;

});
parcelRegister("fyyKn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::456639fbdc991aefe1af05acf697365d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b534fc02f8c45cab$var$_react = $b534fc02f8c45cab$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b534fc02f8c45cab$var$_baseNew = $b534fc02f8c45cab$var$_interopRequireDefault((parcelRequire("lfiRe")));
function $b534fc02f8c45cab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b534fc02f8c45cab$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $b534fc02f8c45cab$var$_react.default.createElement($b534fc02f8c45cab$var$_baseNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$b534fc02f8c45cab$var$StatusInformationIcon.displayName = "StatusInformationIcon";
var $b534fc02f8c45cab$var$_default = module.exports.default = $b534fc02f8c45cab$var$StatusInformationIcon;

});

parcelRegister("ekJkm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6f61807c4e47de4$var$_react = $a6f61807c4e47de4$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $eRdqf = parcelRequire("eRdqf");
function $a6f61807c4e47de4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a6f61807c4e47de4$var$InfoIcon = (props)=>/*#__PURE__*/ $a6f61807c4e47de4$var$_react.default.createElement($eRdqf.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props));
$a6f61807c4e47de4$var$InfoIcon.displayName = "InfoIcon";
var $a6f61807c4e47de4$var$_default = module.exports.default = $a6f61807c4e47de4$var$InfoIcon;

});


parcelRegister("fn8KK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f966e8890debb57eaf4e6f167681f98b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b30fcb282bff4c60$var$_react = $b30fcb282bff4c60$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b30fcb282bff4c60$var$_statusSuccess = $b30fcb282bff4c60$var$_interopRequireDefault((parcelRequire("cOE5G")));

var $b30fcb282bff4c60$var$_checkCircle = $b30fcb282bff4c60$var$_interopRequireDefault((parcelRequire("hY5nq")));
function $b30fcb282bff4c60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b30fcb282bff4c60$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $b30fcb282bff4c60$var$_react.default.createElement($b30fcb282bff4c60$var$_statusSuccess.default, Object.assign({
        name: "StatusSuccessIcon",
        LEGACY_fallbackIcon: $b30fcb282bff4c60$var$_checkCircle.default
    }, props));
$b30fcb282bff4c60$var$StatusSuccessIcon.displayName = "StatusSuccessIconMigration";
var $b30fcb282bff4c60$var$_default = module.exports.default = $b30fcb282bff4c60$var$StatusSuccessIcon;

});
parcelRegister("cOE5G", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $954940b44c72564e$var$_react = $954940b44c72564e$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $954940b44c72564e$var$_baseNew = $954940b44c72564e$var$_interopRequireDefault((parcelRequire("lfiRe")));
function $954940b44c72564e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $954940b44c72564e$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $954940b44c72564e$var$_react.default.createElement($954940b44c72564e$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$954940b44c72564e$var$StatusSuccessIcon.displayName = "StatusSuccessIcon";
var $954940b44c72564e$var$_default = module.exports.default = $954940b44c72564e$var$StatusSuccessIcon;

});

parcelRegister("hY5nq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d14c3602fa9f9d26$var$_react = $d14c3602fa9f9d26$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $eRdqf = parcelRequire("eRdqf");
function $d14c3602fa9f9d26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d14c3602fa9f9d26$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $d14c3602fa9f9d26$var$_react.default.createElement($eRdqf.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props));
$d14c3602fa9f9d26$var$CheckCircleIcon.displayName = "CheckCircleIcon";
var $d14c3602fa9f9d26$var$_default = module.exports.default = $d14c3602fa9f9d26$var$CheckCircleIcon;

});


parcelRegister("5b5Vl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::715767a087f47b16ede12b841c1dd7f2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c52932f144a92cf$var$_react = $3c52932f144a92cf$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $3c52932f144a92cf$var$_statusWarning = $3c52932f144a92cf$var$_interopRequireDefault((parcelRequire("260O1")));

var $3c52932f144a92cf$var$_warning = $3c52932f144a92cf$var$_interopRequireDefault((parcelRequire("59G3R")));
function $3c52932f144a92cf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusWarningIcon.
 * This component is StatusWarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3c52932f144a92cf$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $3c52932f144a92cf$var$_react.default.createElement($3c52932f144a92cf$var$_statusWarning.default, Object.assign({
        name: "StatusWarningIcon",
        LEGACY_fallbackIcon: $3c52932f144a92cf$var$_warning.default
    }, props));
$3c52932f144a92cf$var$StatusWarningIcon.displayName = "StatusWarningIconMigration";
var $3c52932f144a92cf$var$_default = module.exports.default = $3c52932f144a92cf$var$StatusWarningIcon;

});
parcelRegister("260O1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee7b3f114c675eea0f953c33a485bcf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $186cc4510cd64da9$var$_react = $186cc4510cd64da9$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $186cc4510cd64da9$var$_baseNew = $186cc4510cd64da9$var$_interopRequireDefault((parcelRequire("lfiRe")));
function $186cc4510cd64da9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $186cc4510cd64da9$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $186cc4510cd64da9$var$_react.default.createElement($186cc4510cd64da9$var$_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$186cc4510cd64da9$var$StatusWarningIcon.displayName = "StatusWarningIcon";
var $186cc4510cd64da9$var$_default = module.exports.default = $186cc4510cd64da9$var$StatusWarningIcon;

});

parcelRegister("59G3R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c0e6b7b4a2ef97c$var$_react = $3c0e6b7b4a2ef97c$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $eRdqf = parcelRequire("eRdqf");
function $3c0e6b7b4a2ef97c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3c0e6b7b4a2ef97c$var$WarningIcon = (props)=>/*#__PURE__*/ $3c0e6b7b4a2ef97c$var$_react.default.createElement($eRdqf.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$3c0e6b7b4a2ef97c$var$WarningIcon.displayName = "WarningIcon";
var $3c0e6b7b4a2ef97c$var$_default = module.exports.default = $3c0e6b7b4a2ef97c$var$WarningIcon;

});


parcelRegister("imJwX", function(module, exports) {

$parcel$export(module.exports, "R50", function () { return $d5ed9982f1444d9a$export$4b84fd0e2c617bd; });
$parcel$export(module.exports, "R500", function () { return $d5ed9982f1444d9a$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y50", function () { return $d5ed9982f1444d9a$export$8d9596b529bbb9cf; });
$parcel$export(module.exports, "Y500", function () { return $d5ed9982f1444d9a$export$874739ea9e379ab6; });
$parcel$export(module.exports, "G50", function () { return $d5ed9982f1444d9a$export$8a6341c32b6a3ee6; });
$parcel$export(module.exports, "G500", function () { return $d5ed9982f1444d9a$export$6fa04827ac68a4fb; });
$parcel$export(module.exports, "B50", function () { return $d5ed9982f1444d9a$export$226de0355ed012f8; });
$parcel$export(module.exports, "B500", function () { return $d5ed9982f1444d9a$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "P50", function () { return $d5ed9982f1444d9a$export$363e4475840015bb; });
$parcel$export(module.exports, "P500", function () { return $d5ed9982f1444d9a$export$147899de772240ec; });
// Reds
var $d5ed9982f1444d9a$export$4b84fd0e2c617bd = "#FFEBE6";
var $d5ed9982f1444d9a$export$b34b069eff244586 = "#FFBDAD";
var $d5ed9982f1444d9a$export$be802dd0d8b57f35 = "#FF8F73";
var $d5ed9982f1444d9a$export$60847d42f9da92a6 = "#FF7452";
var $d5ed9982f1444d9a$export$4a7404f376229999 = "#FF5630";
var $d5ed9982f1444d9a$export$2010d0fb4295b346 = "#DE350B";
var $d5ed9982f1444d9a$export$2837b5a1a71d5c02 = "#BF2600";
var $d5ed9982f1444d9a$export$8d9596b529bbb9cf = "#FFFAE6";
var $d5ed9982f1444d9a$export$41060a744ab0b7ae = "#FFF0B3";
var $d5ed9982f1444d9a$export$1cc05bbbf340e559 = "#FFE380";
var $d5ed9982f1444d9a$export$5aae31392d72caaa = "#FFC400";
var $d5ed9982f1444d9a$export$c6930421db9fa514 = "#FFAB00";
var $d5ed9982f1444d9a$export$59619663aa6500fb = "#FF991F";
var $d5ed9982f1444d9a$export$874739ea9e379ab6 = "#FF8B00";
var $d5ed9982f1444d9a$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $d5ed9982f1444d9a$export$69a3bf21b9686c2b = "#ABF5D1";
var $d5ed9982f1444d9a$export$afbce1382ec95f73 = "#79F2C0";
var $d5ed9982f1444d9a$export$747d86715d4175de = "#57D9A3";
var $d5ed9982f1444d9a$export$940e1f69e873f202 = "#36B37E";
var $d5ed9982f1444d9a$export$a49394138f7b8e85 = "#00875A";
var $d5ed9982f1444d9a$export$6fa04827ac68a4fb = "#006644";
var $d5ed9982f1444d9a$export$226de0355ed012f8 = "#DEEBFF";
var $d5ed9982f1444d9a$export$8c13c2ee36917869 = "#B3D4FF";
var $d5ed9982f1444d9a$export$ecfc1dff386a3e7a = "#4C9AFF";
var $d5ed9982f1444d9a$export$215b7063051591f1 = "#2684FF";
var $d5ed9982f1444d9a$export$e62e8919cca44969 = "#0065FF";
var $d5ed9982f1444d9a$export$b3de0ae08da2ce64 = "#0052CC";
var $d5ed9982f1444d9a$export$a6ee3d71bc067634 = "#0747A6";
var $d5ed9982f1444d9a$export$67f15409e87642a1 = "#669DF1";
var $d5ed9982f1444d9a$export$f0539dbc42dbb067 = "#8FB8F6";
var $d5ed9982f1444d9a$export$363e4475840015bb = "#EAE6FF";
var $d5ed9982f1444d9a$export$4b0a4417ed59760f = "#C0B6F2";
var $d5ed9982f1444d9a$export$6011520a64d9a187 = "#998DD9";
var $d5ed9982f1444d9a$export$a7175d4e9206bc80 = "#8777D9";
var $d5ed9982f1444d9a$export$b48405b95304b5a1 = "#6554C0";
var $d5ed9982f1444d9a$export$c71e4279dd54a18d = "#5243AA";
var $d5ed9982f1444d9a$export$147899de772240ec = "#403294";
var $d5ed9982f1444d9a$export$2cf711fe14c66f06 = "#E6FCFF";
var $d5ed9982f1444d9a$export$7a8f4d33f6f9772c = "#B3F5FF";
var $d5ed9982f1444d9a$export$776c9c497ef08533 = "#79E2F2";
var $d5ed9982f1444d9a$export$69cb3ca10c1e330e = "#00C7E6";
var $d5ed9982f1444d9a$export$9dc1ef0f3f48059b = "#00B8D9";
var $d5ed9982f1444d9a$export$7c835c78b6fcdef8 = "#00A3BF";
var $d5ed9982f1444d9a$export$6036577f95c3877e = "#008DA6";
var $d5ed9982f1444d9a$export$29a4f05edc054374 = "#FFFFFF";
var $d5ed9982f1444d9a$export$e655ef011c4aa1a2 = "#FAFBFC";
var $d5ed9982f1444d9a$export$9fdfb749e33cdf97 = "#F4F5F7";
var $d5ed9982f1444d9a$export$3e51e8f1440314ba = "#EBECF0";
var $d5ed9982f1444d9a$export$1ce2d1575d444ceb = "#DFE1E6";
var $d5ed9982f1444d9a$export$8754fc7e6d8b3000 = "#C1C7D0";
var $d5ed9982f1444d9a$export$c2e91cbeada39b8b = "#B3BAC5";
var $d5ed9982f1444d9a$export$5f71e19f3a7ad9de = "#A5ADBA";
var $d5ed9982f1444d9a$export$eaa8c8a70ac22806 = "#97A0AF";
var $d5ed9982f1444d9a$export$7c87d337fb91a97d = "#8993A4";
var $d5ed9982f1444d9a$export$d6447c357493214f = "#7A869A";
var $d5ed9982f1444d9a$export$f563ee71e9ee74cd = "#6B778C";
var $d5ed9982f1444d9a$export$e2ef2124cf4024b1 = "#5E6C84";
var $d5ed9982f1444d9a$export$eece5f492e429f08 = "#505F79";
var $d5ed9982f1444d9a$export$c39c0fe0f26207ae = "#42526E";
var $d5ed9982f1444d9a$export$7090862dc3038a9f = "#344563";
var $d5ed9982f1444d9a$export$ad0bacf983b7ddaa = "#253858";
var $d5ed9982f1444d9a$export$7d61b15e0da132af = "#172B4D";
var $d5ed9982f1444d9a$export$fbda843f0a27fe96 = "#091E42";
var $d5ed9982f1444d9a$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $d5ed9982f1444d9a$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $d5ed9982f1444d9a$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $d5ed9982f1444d9a$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $d5ed9982f1444d9a$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $d5ed9982f1444d9a$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $d5ed9982f1444d9a$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $d5ed9982f1444d9a$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $d5ed9982f1444d9a$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $d5ed9982f1444d9a$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $d5ed9982f1444d9a$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $d5ed9982f1444d9a$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $d5ed9982f1444d9a$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $d5ed9982f1444d9a$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $d5ed9982f1444d9a$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $d5ed9982f1444d9a$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $d5ed9982f1444d9a$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $d5ed9982f1444d9a$export$2f6319cf7d736c2a = "#E6EDFA";
var $d5ed9982f1444d9a$export$95126bc8884d6634 = "#DCE5F5";
var $d5ed9982f1444d9a$export$8338d8c35d44ff1 = "#CED9EB";
var $d5ed9982f1444d9a$export$5368d76ae4fbbda7 = "#B8C7E0";
var $d5ed9982f1444d9a$export$9f0a771d16ec8d36 = "#ABBBD6";
var $d5ed9982f1444d9a$export$abcf8c38338b4aa5 = "#9FB0CC";
var $d5ed9982f1444d9a$export$97e81faa16a182c7 = "#8C9CB8";
var $d5ed9982f1444d9a$export$bfe21c59123ecf33 = "#7988A3";
var $d5ed9982f1444d9a$export$ee82aa2ea6a1558 = "#67758F";
var $d5ed9982f1444d9a$export$682927c6ed76be02 = "#56637A";
var $d5ed9982f1444d9a$export$91fd9994c5be9757 = "#455166";
var $d5ed9982f1444d9a$export$d281fbfe3cff2df6 = "#3B475C";
var $d5ed9982f1444d9a$export$3902c91d8b98a753 = "#313D52";
var $d5ed9982f1444d9a$export$8e8133c1ba5845b5 = "#283447";
var $d5ed9982f1444d9a$export$33ff357f6620b39 = "#202B3D";
var $d5ed9982f1444d9a$export$633847cf062b69e0 = "#1B2638";
var $d5ed9982f1444d9a$export$9776a6e503bdbf76 = "#121A29";
var $d5ed9982f1444d9a$export$6c813d5160dff5db = "#0E1624";
var $d5ed9982f1444d9a$export$3d4f271a500072a = "#0D1424";
var $d5ed9982f1444d9a$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $d5ed9982f1444d9a$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $d5ed9982f1444d9a$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $d5ed9982f1444d9a$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $d5ed9982f1444d9a$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $d5ed9982f1444d9a$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $d5ed9982f1444d9a$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $d5ed9982f1444d9a$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $d5ed9982f1444d9a$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $d5ed9982f1444d9a$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $d5ed9982f1444d9a$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $d5ed9982f1444d9a$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $d5ed9982f1444d9a$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $d5ed9982f1444d9a$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $d5ed9982f1444d9a$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $d5ed9982f1444d9a$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $d5ed9982f1444d9a$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $d5ed9982f1444d9a$export$d2adc5dedf09fced = "#292A2E";
var $d5ed9982f1444d9a$export$f51762073d2bb381 = "#94C748";
var $d5ed9982f1444d9a$export$95e26d54def96891 = "#B3DF72";

});




//# sourceMappingURL=direct-buy-org-setup-container.1a9c4cbb.js.map
